/* eslint-disable */
import React from 'react';
import { ratioCalculations, ratioCalculationsMoney, calculateEBITDA, netWorkingCapitalCalculation, netWorkingCapitalRatioCalculation, trailing12MonthCalculations } from '../monthly/monthy_analysis_table_trailing12_calculations';
const doctorsNAICS = ['621', '6211', '6213'];
// Used by Monthly and YTD Sheets/Tables
let monthArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const getYTDMonthCount = (data, ytdMonths) => {
  if (!data || !Array.isArray(ytdMonths)) return 0;
  return ytdMonths.filter((m) => _.isNumber(data[m])).length;
};

const getYTDMonths = (data, ytdMonths) => {
  if (!data || !Array.isArray(ytdMonths)) return [];
  return ytdMonths.map((m) => data[m]);
};

// Monthly and Year to Date, P&L and Balance Sheet
const CommonSizeArrowsHelper = (props) => {
  let arrowCellClass = props.pdf ? 'common-size-arrow-pdf' : 'common-size-arrow';

  if (_.isEmpty(props.passedCalcs)) {
    return <td className={`${arrowCellClass} ${props.cssClass}`} style={props.style}></td>;
  }

  let arrow;

  if (props.sheet === 'pnl') {
    const reducedArrayYou = props.display === 'monthly' ? props.arrayYou.reduce((a, b) => a + b, 0) : props.valueYou;
    const reducedArrayComparedTo = props.display === 'monthly' ? props.arrayCompareTo.slice(0, props.monthsAvailable).reduce((a, b) => a + b, 0) : props.valueCompareTo;
    let totalRevenueYou = 0;
    let totalRevenueCompareTo = 0;

    if (props.display === 'monthly') {
      totalRevenueYou = Object.values(props.youTotRev || {}).reduce((a, b) => a + b, 0);
      totalRevenueCompareTo = Object.values(props.passedCalcs?.['total_revenue']?.[props.selectedYear] || {}).slice(0, props.monthsAvailable).reduce((a, b) => a + b, 0);
    } else {
      // Year to Date
      totalRevenueYou = (props.ytdMonths || []).map(m => props.youTotRev?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
      totalRevenueCompareTo = (props.ytdMonths || []).map(m => props.passedCalcs?.['total_revenue']?.[props.selectedYear]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
    }

    const you = totalRevenueYou ? (reducedArrayYou / totalRevenueYou) * 100 : 0;
    const compareTo = totalRevenueCompareTo ? (reducedArrayComparedTo / totalRevenueCompareTo) * 100 : 0;
    arrow = CommonSizeArrows(you, compareTo, props.keyArrBuilder)
  } else {
    let totalAssetsYouVal = null;
    let totalAssetsCompareVal = null;
    let youValue = null;
    let compareValue = null;

    if (props.display === 'monthly') {
      const totalAssetsYou = Object.values(props.youTotAssets || {}).filter(_.isNumber);
      const numberOfValues = totalAssetsYou.length;

      totalAssetsYouVal = totalAssetsYou[numberOfValues - 1] ?? null;
      youValue = props.arrayYou[numberOfValues - 1]

      const totalAssetsCompareTo = Object.values(props.passedCalcs?.['total_assets']?.[props.selectedYear] || {}).filter(_.isNumber);
      totalAssetsCompareVal = totalAssetsCompareTo[props.monthsAvailable - 1] ?? null;
      compareValue = props.arrayCompareTo[props.monthsAvailable - 1];
    } else {
      // Year to Date
      const youAssetsObj = props.youTotAssets || {};
      const compareAssetsObj = props.passedCalcs?.['total_assets']?.[props.selectedYear] || {};

      const lastValidYouMonth = [...props.ytdMonths].reverse().find(m => _.isNumber(youAssetsObj[m]));
      const lastValidCompareMonth = [...props.ytdMonths].reverse().find(m => _.isNumber(compareAssetsObj[m]));

      totalAssetsYouVal = youAssetsObj[lastValidYouMonth] ?? null;
      totalAssetsCompareVal = compareAssetsObj[lastValidCompareMonth] ?? null;

      youValue = props.valueYou;
      compareValue = props.valueCompareTo;
    }

    const you = _.isNumber(totalAssetsYouVal) ? (youValue / totalAssetsYouVal) * 100 : 0;
    const compareTo = _.isNumber(totalAssetsCompareVal) ? (compareValue / totalAssetsCompareVal) * 100 : 0;
    arrow = CommonSizeArrows(you, compareTo, props.keyArrBuilder)
  }

  if (arrow === 'better' || arrow === 'best') {
    arrow = <p className='common-size-arrow-green' style={{ margin: 0, color: 'green' }}>&#9650;</p>
  } else if (arrow === 'worse' || arrow == 'worst') {
    arrow = <p className='common-size-arrow-red' style={{ margin: 0, color: 'red' }}>&#9660;</p>
  } else {
    arrow = ''
  }

  return (<td className={`${arrowCellClass} ${props.cssClass}`} style={props.style}>{arrow}</td>)
}

const CommonSizeArrows = (you, avg, key, parentKey = '') => {
  // Common sized values
  const goodUpArrowKeys = [
    'total_revenue',
    'total_revenue_gross_charges',
    'gross_profit',
    'operating_profit',
    'operating_expenses_net_income',
    'total_current_assets',
    'total_fixed_assets',
    'total_assets',
    'ebitda',
  ];
  const goodUpBalanceSheetParents = ['total_current_assets', 'total_fixed_assets', 'total_assets'];
  const ingoreArrowKeys = ['net_worth', 'total_liabilities_and_equity'];
  let keyIsGoodUp = goodUpArrowKeys.includes(key);
  if (goodUpBalanceSheetParents.includes(parentKey)) {
    keyIsGoodUp = true;
  }
  if (ingoreArrowKeys.includes(key) || ingoreArrowKeys.includes(parentKey)) {
    return 'maintain';
  }
  let rangeWorst;
  let rangeWorse;
  let rangeBetter;
  let rangeBest;
  if (avg !== null) {
    rangeWorst = avg - 10;
    rangeWorse = avg - 5;
    rangeBetter = avg + 5;
    rangeBest = avg + 10;
  }

  if (rangeWorse < you && you < rangeBetter) {
    return 'maintain';
  } else if (rangeWorst < you && you < rangeWorse) {
    return keyIsGoodUp ? 'worse' : 'better';
  } else if (you < rangeWorst) {
    return keyIsGoodUp ? 'worst' : 'best';
  } else if (rangeBest > you && you > rangeBetter) {
    return keyIsGoodUp ? 'better' : 'worse';
  } else if (you > rangeBest) {
    return keyIsGoodUp ? 'best' : 'worst';
  } else {
    return 'n/a';
  }
}

const YTDPnlandBalCommonSizeValue = (value, sheet, year, ytdMonths, calcs) => {
  if (!_.isNumber(value)) return undefined;

  if (sheet === 'pnl' || ['people_financial_detail', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
    const totalRevenueByMonth = calcs?.['total_revenue']?.[year] || {};
    const ytdRevenue = ytdMonths.map(m => totalRevenueByMonth[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);

    return ytdRevenue ? value / ytdRevenue : 0;
  }

  if (sheet === 'balance_sheet') {
    const totalAssetsByMonth = calcs?.['total_assets']?.[year] || {};
    // Get the most recent non-null month
    const lastValidMonth = [...ytdMonths].reverse().find(m => _.isNumber(totalAssetsByMonth[m]));

    const latestTotalAssets = _.isNumber(totalAssetsByMonth[lastValidMonth])
      ? totalAssetsByMonth[lastValidMonth]
      : 0;

    return latestTotalAssets ? value / latestTotalAssets : 0;
  }

  return undefined;
};


const totalNAICSYTD = (naicsCode, key, year, ytdMonths, calcs, rows) => {
  let childrenObjs = rows.filter(r => r.parentKey === key);
  let childrenValues = [];

  childrenObjs.forEach((c) => {
    let totalVal = 0;

    if (c.key === "salaries_non_owners") {
      const youTotalCompensation = (ytdMonths || []).map(m => calcs?.['total_compensation']?.[year]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
      let youSalariesDoctor = 0

      if (naicsCode?.startsWith('6212')) {
        youSalariesDoctor = (ytdMonths || []).map(m => calcs?.['dentist']?.[year]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
      } else if (naicsCode && doctorsNAICS.some(naics => naicsCode.startsWith(naics))) {
        youSalariesDoctor = (ytdMonths || []).map(m => calcs?.['total_compensation_doctor']?.[year]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
      }

      totalVal = youTotalCompensation - youSalariesDoctor;
    } else {
      c.map_keys.forEach((mk) => {
        const values = (ytdMonths || []).map(m => calcs?.[mk]?.[year]?.[m]).filter(_.isNumber);
        totalVal += values.reduce((a, b) => a + b, 0);
      });
    }
    childrenValues.push(totalVal)
  })

  return childrenValues.reduce((a, b) => a + b, 0)
}

const YTDNAICSFocusedVals = (naicsCode, key, map_keys, year, ytdMonths, allCalcs, rows = '') => {
  let finalValue = null;

  if (key === 'total_direct_costs' || key === 'total_administrative_costs') {
    finalValue = totalNAICSYTD(naicsCode, key, year, ytdMonths, allCalcs, rows)
  } else if (key === 'gross_profit') {
    const totalDirectCosts = totalNAICSYTD(naicsCode, 'total_direct_costs', year, ytdMonths, allCalcs, rows)
    const totalRevenue = (ytdMonths || []).map(m => allCalcs?.['total_revenue']?.[year]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
    finalValue = totalRevenue - totalDirectCosts
  } else if (key === 'operating_expenses_net_income') {
    const totalDirectCosts = totalNAICSYTD(naicsCode, 'total_direct_costs', year, ytdMonths, allCalcs, rows)
    const totalAdminCosts = totalNAICSYTD(naicsCode, 'total_administrative_costs', year, ytdMonths, allCalcs, rows)
    const totalRevenue = (ytdMonths || []).map(m => allCalcs?.['total_revenue']?.[year]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
    finalValue = totalRevenue - totalDirectCosts - totalAdminCosts
  } else if (key === 'salaries_non_owners') {
    // const totalRevenue = (ytdMonths || []).map(m => allCalcs?.['total_revenue']?.[year]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
    const totalCompensation = (ytdMonths || []).map(m => allCalcs?.['total_compensation']?.[year]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
    let salariesDoctor = 0

    if (naicsCode && naicsCode.startsWith('6212')) {
      salariesDoctor = (ytdMonths || []).map(m => allCalcs?.['dentist']?.[year]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
    } else if (props.naicsCode && doctorsNAICS.some(naics => props.naicsCode.startsWith(naics))) {
      salariesDoctor = (ytdMonths || []).map(m => allCalcs?.['total_compensation_doctor']?.[year]?.[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
    }
    finalValue = totalCompensation - salariesDoctor
  } else {
    let values = [];
    map_keys.forEach(mk => {
      const monthlyValues = (ytdMonths || []).map(m => allCalcs?.[mk]?.[year]?.[m]).filter(_.isNumber);
      values = [...values, ...monthlyValues];
    });
    finalValue = values.reduce((a, b) => a + b, 0);
  }
  return finalValue
}

// YTD PNL and Balance Sheet Values
const YTDPnlandBalValues = (sheet, key, metricValues, year, ytdMonths = [], allCalcs) => {
  let finalValue = null;
  const netWorth = sheet === 'balance_sheet' && key === 'net_worth';
  const totalLiabilitiesAndEquity = sheet === 'balance_sheet' && key === 'total_liabilities_and_equity';

  if (metricValues && !finalValue) {
    if (sheet === 'pnl') {
      const values = ytdMonths.map(m => metricValues[m]).filter(_.isNumber);
      finalValue = values.reduce((a, b) => a + b, 0)
      // Are the People and Customers using this function for YTD?
    } else if (['people_financial_detail', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
      const values = ytdMonths.map(m => metricValues[m]).filter(_.isNumber);
      finalValue = values.reduce((a, b) => a + b, 0)
    } else {
      const values = ytdMonths.map(m => metricValues[m]).filter(_.isNumber);
      if (key === 'operating_expenses_net_income') {
        finalValue = values.reduce((a, b) => a + b, 0)
      } else if (netWorth) {
        const netWorthVals = [];
        let memory = 0;

        for (let i of ytdMonths) {
          memory += _.isNumber(allCalcs?.['operating_expenses_net_income']?.[year]?.[i]) ? allCalcs?.['operating_expenses_net_income'][year][i] : 0;
          const capitalStock = _.isNumber(allCalcs?.['capital_stock']?.[year]?.[i]) ? allCalcs?.['capital_stock'][year][i] : 0;
          const retainedEarnings = _.isNumber(allCalcs?.['retained_earnings']?.[year]?.[i]) ? allCalcs?.['retained_earnings'][year][i] : 0;
          const ownerDistributions = _.isNumber(allCalcs?.['owner_distributions']?.[year]?.[i]) ? allCalcs?.['owner_distributions'][year][i] : 0;

          netWorthVals[i] = memory + capitalStock + retainedEarnings + ownerDistributions;
        }

        const filteredNetWorthVals = Object.values(netWorthVals).filter(_.isNumber);
        finalValue = filteredNetWorthVals[filteredNetWorthVals.length - 1];
      } else if (totalLiabilitiesAndEquity) {
        const liabEqVals = ytdMonths.map(m => allCalcs?.['total_assets']?.[year]?.[m]).filter(_.isNumber);
        finalValue = liabEqVals[liabEqVals.length - 1];
      } else {
        finalValue = values[values.length - 1];
      }
    }
  }
  return finalValue

}

const totalNAICSFocusedMonthly = (naicsCode, monthsAvailable, key, selectedYear, calcs, rows) => {
  let valuesArr = []
  let childrenObjs = rows.filter(r => r.parentKey === key)
  for (let i = 1; i < monthsAvailable + 1; i++) {
    let youSum = 0;
    childrenObjs.forEach((c) => {
      if (c.key === "salaries_non_owners") {
        let youTotalCompensation = calcs?.['total_compensation']?.[selectedYear]?.[i] || 0
        let youSalariesDoctor = 0

        if (naicsCode && naicsCode.startsWith('6212')) {
          youSalariesDoctor = calcs?.['dentist']?.[selectedYear]?.[i] ?? 0
        } else if (naicsCode && doctorsNAICS.some(naics => naicsCode.startsWith(naics))) {
          youSalariesDoctor = calcs?.['total_compensation_doctor']?.[selectedYear]?.[i] ?? 0
        }

        youSum = youTotalCompensation - youSalariesDoctor;
      } else {
        c.map_keys.forEach((mk) => {
          youSum += calcs?.[mk]?.[selectedYear]?.[i] ?? 0;
        });
      }
    });
    valuesArr[i - 1] = youSum;
  }
  return valuesArr;
}

const MonthlyNAICSFocusedVals = (naicsCode, monthsAvailable, key, map_keys, selectedYear, allCalcs, rows) => {
  let valuesArr = [];

  if (key === 'operating_expenses_net_income') {
    const totalDirectCosts = totalNAICSFocusedMonthly(naicsCode, monthsAvailable, 'total_direct_costs', selectedYear, allCalcs, rows);
    const totalAdminCosts = totalNAICSFocusedMonthly(naicsCode, monthsAvailable, 'total_administrative_costs', selectedYear, allCalcs, rows);

    valuesArr = totalDirectCosts.map((t, i) => {
      return allCalcs?.['total_revenue'][selectedYear] && allCalcs?.['total_revenue'][selectedYear][i + 1] ? allCalcs?.['total_revenue'][selectedYear][i + 1] - t - totalAdminCosts[i] : 0;
    });
  } else if (key === 'gross_profit') {
    const totalDirectCosts = totalNAICSFocusedMonthly(naicsCode, monthsAvailable, 'total_direct_costs', selectedYear, allCalcs, rows);

    valuesArr = totalDirectCosts.map((t, i) => {
      return allCalcs?.['total_revenue'][selectedYear] && allCalcs?.['total_revenue'][selectedYear][i + 1] ? allCalcs?.['total_revenue'][selectedYear][i + 1] - t : 0;
    });
  } else if (key === 'total_direct_costs' || key === 'total_administrative_costs') {
    valuesArr = totalNAICSFocusedMonthly(naicsCode, monthsAvailable, key, selectedYear, allCalcs, rows)
  } else {
    for (let i = 1; i < monthsAvailable + 1; i++) {
      let youSum = 0;
      map_keys.forEach(mk => {
        youSum += allCalcs?.[mk]?.[selectedYear]?.[i] ? allCalcs?.[mk][selectedYear][i] : 0
      });
      valuesArr[i - 1] = youSum;
    }
  }

  return valuesArr;
}

// Monthly PNL and Balance Sheet Values
const MonthlyPNLandBalValues = (monthsAvailable, sheet, key, metricValues, selectedYear, allCalcs) => {
  let valuesArr = [];
  const bsNetIncome = sheet === 'balance_sheet' && key === 'operating_expenses_net_income';
  const netWorth = sheet === 'balance_sheet' && key === 'net_worth'
  const totalLiabilitiesAndEquity = sheet === 'balance_sheet' && key === 'total_liabilities_and_equity';

  if (metricValues && valuesArr.length === 0) {
    monthArr.forEach((month, index) => {
      if (index < monthsAvailable) {
        const val = _.isNumber(metricValues[month]) ? metricValues[month] : 0;
        valuesArr.push(val);
      } else {
        valuesArr.push(null);
      }
    })
  }

  if (metricValues && bsNetIncome) {
    for (let i = 1; i < monthsAvailable + 1; i++) {
      if (i !== monthsAvailable) {
        valuesArr[i] += valuesArr[i - 1]
      }
    }
  }

  if (metricValues && netWorth) {
    let memory = 0
    for (let i = 1; i < monthsAvailable + 1; i++) {
      memory += allCalcs?.['operating_expenses_net_income']?.[selectedYear]?.[i]
      valuesArr[i - 1] = memory + allCalcs?.['capital_stock']?.[selectedYear]?.[i] + allCalcs?.['retained_earnings']?.[selectedYear]?.[i] + allCalcs?.['owner_distributions']?.[selectedYear]?.[i]
    }
  }

  if (metricValues && totalLiabilitiesAndEquity) {
    for (let i = 1; i < monthsAvailable + 1; i++) {
      valuesArr[i - 1] = allCalcs?.['total_assets']?.[selectedYear]?.[i]
    }
  }

  return valuesArr;
}

const MonthlyPNLandBalCommonSized = (sheet, metricValsArr, selectedYear, allCalcs) => {
  const filteredValues = metricValsArr.filter(_.isNumber);
  if (filteredValues.length === 0) return null;

  if (sheet === 'pnl' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
    const reducedArray = filteredValues.reduce((a, b) => a + b, 0)
    if (_.isNumber(reducedArray)) {
      const totalRevenue = Object.values(allCalcs?.['total_revenue']?.[selectedYear] || {}).slice(0, filteredValues.length).reduce((a, b) => a + b, 0)
      return totalRevenue ? reducedArray / totalRevenue : null;
    }
  }
  if (sheet === 'balance_sheet') {
    const totalAssets = Object.values(allCalcs?.['total_assets']?.[selectedYear] || {}).slice(0, filteredValues.length).filter(val => _.isNumber(val))
    let numberOfValues = totalAssets.length;
    const totalAssetsValue = numberOfValues > 0 ? totalAssets[numberOfValues - 1] : null;
    if (_.isNumber(metricValsArr[0]) && _.isNumber(totalAssetsValue)) {
      let lastValue = numberOfValues > 0 ? metricValsArr[numberOfValues - 1] : null;
      return totalAssetsValue ? lastValue / totalAssetsValue : null
    }
  }
}

const getMonthlyVal = (data, key, year) => data?.[key]?.[year] || {};

const isEmpty = (obj) => !obj || Object.keys(obj).length === 0;

const PreviousMonthMinusCurrentMonthAmount = (currentYear, previousYear, ytdView = false, ytdMonths = []) => {
  let prevMinusCurrent = {};
  for (let i = 1; i <= 12; i++) {
    if (ytdView && !ytdMonths.includes(i)) {
      prevMinusCurrent[i] = null;
      continue;
    }

    // Empty object fallback
    if (isEmpty(currentYear) || isEmpty(previousYear)) {
      prevMinusCurrent[i] = null;
      continue;
    }

    if (i === 1) {
      const prev = previousYear[12];
      const curr = currentYear[1];
      prevMinusCurrent[i] = (_.isNumber(prev) && _.isNumber(curr)) ? prev - curr : null;
    } else {
      const prev = currentYear[i - 1];
      const curr = currentYear[i];
      prevMinusCurrent[i] = (_.isNumber(prev) && _.isNumber(curr)) ? prev - curr : null;
    }
  }

  if (ytdView) {
    prevMinusCurrent = Object.values(prevMinusCurrent).filter(_.isNumber).reduce((a, b) => a + b, 0);
  }

  return prevMinusCurrent
}

const CurrentMonthMinusPreviousMonthAmount = (currentYear, previousYear, ytdView = false, ytdMonths = []) => {
  let currentMinusPrev = {}
  for (let i = 1; i <= 12; i++) {
    if (ytdView && !ytdMonths.includes(i)) {
      currentMinusPrev[i] = null;
      continue;
    }

    // Check for empty objects
    if (isEmpty(currentYear) || isEmpty(previousYear)) {
      currentMinusPrev[i] = null;
      continue;
    }


    if (i === 1) {
      const curr = currentYear[1];
      const prev = previousYear[12];
      currentMinusPrev[i] = (_.isNumber(curr) && _.isNumber(prev)) ? curr - prev : null;
    } else {
      const curr = currentYear[i];
      const prev = currentYear[i - 1];
      currentMinusPrev[i] = (_.isNumber(curr) && _.isNumber(prev)) ? curr - prev : null;
    }
  }

  if (ytdView) {
    currentMinusPrev = Object.values(currentMinusPrev).filter(_.isNumber).reduce((a, b) => a + b, 0);
  }

  return currentMinusPrev
}

const getPrevVal = (isForecast, key, previousYear, monthlyData, fallbackPrevYearData) => {
  return isForecast
    ? getMonthlyVal(fallbackPrevYearData, key, previousYear)
    : getMonthlyVal(monthlyData, key, previousYear);
};

// calcs, calcsYear, previousYearCalcs, prevYear, ytdView = false, ytdMonths = []
const netOperatingActivitiesValuesMonths = (monthlyData, selectedYear, previousYear, ytdView = false, ytdMonths = [], isForecast = false, fallbackPrevYearData = null) => {
  let netOperatingActivities = null;

  const accountsReceivable = PreviousMonthMinusCurrentMonthAmount(
    getMonthlyVal(monthlyData, 'accounts_receivable', selectedYear),
    getPrevVal(isForecast, 'accounts_receivable', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths,
  );

  const inventory = PreviousMonthMinusCurrentMonthAmount(
    getMonthlyVal(monthlyData, 'inventory', selectedYear),
    getPrevVal(isForecast, 'inventory', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths,
  );

  const underBillings = PreviousMonthMinusCurrentMonthAmount(
    getMonthlyVal(monthlyData, 'under_billings', selectedYear),
    getPrevVal(isForecast, 'under_billings', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths,
  );

  const prepaidAssets = PreviousMonthMinusCurrentMonthAmount(
    getMonthlyVal(monthlyData, 'prepaid_and_other_current_assets', selectedYear),
    getPrevVal(isForecast, 'prepaid_and_other_current_assets', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths,
  );

  const accountsPayable = CurrentMonthMinusPreviousMonthAmount(
    getMonthlyVal(monthlyData, 'accounts_payable', selectedYear),
    getPrevVal(isForecast, 'accounts_payable', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths
  );

  const accruedLiabilities = CurrentMonthMinusPreviousMonthAmount(
    getMonthlyVal(monthlyData, 'accrued_liabilities', selectedYear),
    getPrevVal(isForecast, 'accrued_liabilities', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths
  );

  const overBillings = CurrentMonthMinusPreviousMonthAmount(
    getMonthlyVal(monthlyData, 'over_billings', selectedYear),
    getPrevVal(isForecast, 'over_billings', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths
  );

  const otherCurrentLiabilities = CurrentMonthMinusPreviousMonthAmount(
    getMonthlyVal(monthlyData, 'other_current_liabilities', selectedYear),
    getPrevVal(isForecast, 'other_current_liabilities', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths
  );

  // Aggregate
  if (ytdView) {
    const netIncomeVals = getMonthlyVal(monthlyData, 'operating_expenses_net_income', selectedYear);
    const deprAmorVals = getMonthlyVal(monthlyData, 'depreciation_and_amortization', selectedYear);

    const netIncome = getYTDMonths(netIncomeVals, ytdMonths).reduce((a, b) => a + b, 0);
    const deprAmor = getYTDMonths(deprAmorVals, ytdMonths).reduce((a, b) => a + b, 0);

    netOperatingActivities = Math.round(
      netIncome +
      deprAmor +
      accountsReceivable +
      inventory +
      underBillings +
      prepaidAssets +
      accountsPayable +
      accruedLiabilities +
      overBillings +
      otherCurrentLiabilities
    );
  } else {
    const netIncomeVals = getMonthlyVal(monthlyData, 'operating_expenses_net_income', selectedYear);
    const deprAmorVals = getMonthlyVal(monthlyData, 'depreciation_and_amortization', selectedYear);

    netOperatingActivities = {};
    for (let i = 1; i <= 12; i++) {
      const netIncome = _.isNumber(netIncomeVals[i]) ? netIncomeVals[i] : 0;
      const deprAmor = _.isNumber(deprAmorVals[i]) ? deprAmorVals[i] : 0;

      netOperatingActivities[i] = Math.round(
        netIncome +
        deprAmor +
        accountsReceivable[i] +
        inventory[i] +
        underBillings[i] +
        prepaidAssets[i] +
        accountsPayable[i] +
        accruedLiabilities[i] +
        overBillings[i] +
        otherCurrentLiabilities[i]
      );
    }
  }

  return netOperatingActivities;
};

const netInvestingActivitiesMonths = (monthlyData, selectedYear, previousYear, ytdView = false, ytdMonths = [], isForecast = false, fallbackPrevYearData = null) => {
  let netInvestingActivities = null;

  const propertyAndEquipment = PreviousMonthMinusCurrentMonthAmount(
    getMonthlyVal(monthlyData, 'property_and_equipment', selectedYear),
    getPrevVal(isForecast, 'property_and_equipment', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths
  );

  const otherLongTermAssets = PreviousMonthMinusCurrentMonthAmount(
    getMonthlyVal(monthlyData, 'other_long_term_assets', selectedYear),
    getPrevVal(isForecast, 'other_long_term_assets', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths
  );

  if (ytdView) {
    netInvestingActivities = Math.round(propertyAndEquipment + otherLongTermAssets);
  } else {
    netInvestingActivities = {};
    for (let i = 1; i <= 12; i++) {
      netInvestingActivities[i] = Math.round(propertyAndEquipment[i] + otherLongTermAssets[i]);
    }
  }

  return netInvestingActivities;
};


const equityMonths = (monthlyData, selectedYear, previousYear, ytdView = false, ytdMonths = [], isForecast = false, fallbackPrevYearData = null) => {
  const newEquity = {};
  const netIncomeVals = getMonthlyVal(monthlyData, 'operating_expenses_net_income', selectedYear);
  const prevNetIncomeVals = getPrevVal(isForecast, 'operating_expenses_net_income', previousYear, monthlyData, fallbackPrevYearData);

  const capitalStockVals = getMonthlyVal(monthlyData, 'capital_stock', selectedYear);
  const retainedEarningsVals = getMonthlyVal(monthlyData, 'retained_earnings', selectedYear);
  const ownerDistributionsVals = getMonthlyVal(monthlyData, 'owner_distributions', selectedYear);

  const prevCapitalStockVals = getPrevVal(isForecast, 'capital_stock', previousYear, monthlyData, fallbackPrevYearData);
  const prevRetainedEarningsVals = getPrevVal(isForecast, 'retained_earnings', previousYear, monthlyData, fallbackPrevYearData);
  const prevOwnerDistributionsVals = getPrevVal(isForecast, 'owner_distributions', previousYear, monthlyData, fallbackPrevYearData);

  // Calculate net worths
  // Current month net worth - current month net income - previous month net worth
  // Need to go through last year's adding up previous month's operating_expenses_net_income for each net worth like balance sheet
  const currentYearNetWorth = {};
  const lastYearNetWorth = {};
  let currentMemory = 0;
  let lastMemory = 0;

  for (let i = 1; i <= 12; i++) {
    const netIncome = _.isNumber(netIncomeVals[i]) ? netIncomeVals[i] : 0;
    const capitalStock = _.isNumber(capitalStockVals[i]) ? capitalStockVals[i] : 0;
    const retainedEarnings = _.isNumber(retainedEarningsVals[i]) ? retainedEarningsVals[i] : 0;
    const ownerDistributions = _.isNumber(ownerDistributionsVals[i]) ? ownerDistributionsVals[i] : 0;

    currentMemory += netIncome;
    currentYearNetWorth[i] = netIncomeVals[i] === null ? null : currentMemory + capitalStock + retainedEarnings + ownerDistributions;

    const prevNetIncome = _.isNumber(prevNetIncomeVals[i]) ? prevNetIncomeVals[i] : 0;
    const prevCapitalStock = _.isNumber(prevCapitalStockVals[i]) ? prevCapitalStockVals[i] : 0;
    const prevRetainedEarnings = _.isNumber(prevRetainedEarningsVals[i]) ? prevRetainedEarningsVals[i] : 0;
    const prevOwnerDistributions = _.isNumber(prevOwnerDistributionsVals[i]) ? prevOwnerDistributionsVals[i] : 0;

    lastMemory += prevNetIncome;
    lastYearNetWorth[i] = prevNetIncomeVals[i] === null ? null : lastMemory + prevCapitalStock + prevRetainedEarnings + prevOwnerDistributions;
  }

  // Calculate new equity
  for (let i = 1; i <= 12; i++) {
    const currentNetWorth = _.isNumber(currentYearNetWorth[i]) ? currentYearNetWorth[i] : null;
    const netIncome = _.isNumber(netIncomeVals[i]) ? netIncomeVals[i] : null;

    const lastNetWorth = i === 1
      ? _.isNumber(lastYearNetWorth[12]) ? lastYearNetWorth[12] : null
      : _.isNumber(currentYearNetWorth[i - 1]) ? currentYearNetWorth[i - 1] : null;

    newEquity[i] = netIncome === null ? null : currentNetWorth - netIncome - lastNetWorth;
  }

  // Return YTD or monthly values
  if (ytdView) {
    // Only sum months in ytdMonths
    return (ytdMonths || []).reduce((sum, m) => {
      return _.isNumber(newEquity[m]) ? sum + newEquity[m] : sum;
    }, 0);
  } else {
    return newEquity;
  }
};

const netFinancingActivitiesValuesMonths = (monthlyData, selectedYear, previousYear, ytdView = false, ytdMonths = [], isForecast = false, fallbackPrevYearData = null) => {
  let netFinancingActivities = null;

  const lineOfCredit = CurrentMonthMinusPreviousMonthAmount(
    getMonthlyVal(monthlyData, 'line_of_credit', selectedYear),
    getPrevVal(isForecast, 'line_of_credit', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths
  );

  const currentPortionOfLTD = CurrentMonthMinusPreviousMonthAmount(
    getMonthlyVal(monthlyData, 'current_portion_of_ltd', selectedYear),
    getPrevVal(isForecast, 'current_portion_of_ltd', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths
  );

  const longTermDebt = CurrentMonthMinusPreviousMonthAmount(
    getMonthlyVal(monthlyData, 'long_term_debt', selectedYear),
    getPrevVal(isForecast, 'long_term_debt', previousYear, monthlyData, fallbackPrevYearData),
    ytdView,
    ytdMonths
  );

  const equity = equityMonths(monthlyData, selectedYear, previousYear, ytdView, ytdMonths, isForecast, fallbackPrevYearData);

  if (ytdView) {
    netFinancingActivities = Math.round(
      lineOfCredit + currentPortionOfLTD + longTermDebt + equity
    );
  } else {
    netFinancingActivities = {};
    for (let i = 1; i <= 12; i++) {
      netFinancingActivities[i] = Math.round(
        lineOfCredit[i] +
        currentPortionOfLTD[i] +
        longTermDebt[i] +
        equity[i]
      );
    }
  }

  return netFinancingActivities;
};

const netChangeInCashValuesMonths = (netOperatingActivities, netInvestingActivities, netFinancingActivities) => {
  const netChangeInCash = {}
  for (let i = 1; i <= 12; i++) {
    netChangeInCash[i] = netOperatingActivities[i] + netInvestingActivities[i] + netFinancingActivities[i]
  }
  return netChangeInCash;
}

const beginCashPeriodMonths = (calcs, selectedYear, previousYear, isForecast = false, fallbackPrevYearData = null) => {
  const cashAtBeginning = {};

  const currentYearCash = getMonthlyVal(calcs, 'cash', selectedYear);
  const previousYearCash = getPrevVal(isForecast, 'cash', previousYear, calcs, fallbackPrevYearData)

  // Month 1 gets beginning value from previous year's December
  cashAtBeginning[1] =
    Object.keys(previousYearCash).length > 0 && _.isNumber(previousYearCash[12])
      ? previousYearCash[12]
      : null;

  // Month 2–12 get beginning value from prior month in same year
  for (let i = 2; i <= 12; i++) {
    // Don't want to show beginning cash for months that we don't have data for
    if (!_.isNumber(currentYearCash[i - 1])) {
      cashAtBeginning[i] = null;
    } else {
      cashAtBeginning[i] = currentYearCash[i - 1];
    }
  }

  return cashAtBeginning;
};

// YTD months CashFlow
const YTDCashFlowValues = (key, calcs, aggregateCalcs, selectedYear, previousYear, ytdMonths, forecast = false, forecastYear = null) => {
  let getNormalYearKeys = ['operating_expenses_net_income', 'depreciation_and_amortization']
  let previousYearFirstKeys = ['accounts_receivable', 'inventory', 'under_billings', 'prepaid_and_other_current_assets', 'property_and_equipment', 'other_long_term_assets']
  let nextYearFirstKeys = ['accounts_payable', 'accrued_liabilities', 'over_billings', 'other_current_liabilities', 'line_of_credit', 'current_portion_of_ltd', 'long_term_debt']
  let youValue = null;
  let compareValue = null;

  let youData = calcs?.you;
  let compareData = forecast ? aggregateCalcs : aggregateCalcs?.avg;
  let comparePresent;
  let compareFirstYear = selectedYear;
  let fallbackPrevYearData = forecast ? youData : null

  if (forecast) {
    compareFirstYear = forecastYear;
    comparePresent = aggregateCalcs?.operating_expenses_net_income?.[compareFirstYear] ? Object.keys(aggregateCalcs?.operating_expenses_net_income?.[compareFirstYear]).length > 0 : false
  } else {
    comparePresent = aggregateCalcs?.avg?.operating_expenses_net_income?.[selectedYear] ? Object.keys(aggregateCalcs?.avg?.operating_expenses_net_income?.[selectedYear]).length > 0 : false
  }

  if (previousYearFirstKeys.includes(key)) {
    let currentValues = getMonthlyVal(youData, key, selectedYear)
    let previousValues = getMonthlyVal(youData, key, previousYear)
    youValue = PreviousMonthMinusCurrentMonthAmount(currentValues, previousValues, true, ytdMonths)
    if (comparePresent) {
      let compareCurrentValues = getMonthlyVal(compareData, key, compareFirstYear)
      let comparePreviousValues = forecast ? previousValues : getMonthlyVal(compareData, key, previousYear)
      compareValue = PreviousMonthMinusCurrentMonthAmount(compareCurrentValues, comparePreviousValues, true, ytdMonths)
    }
  } else if (nextYearFirstKeys.includes(key)) {
    let currentValues = getMonthlyVal(youData, key, selectedYear)
    let previousValues = getMonthlyVal(youData, key, previousYear)
    youValue = CurrentMonthMinusPreviousMonthAmount(currentValues, previousValues, true, ytdMonths)
    if (comparePresent) {
      let compareCurrentValues = getMonthlyVal(compareData, key, compareFirstYear)
      let comparePreviousValues = forecast ? previousValues : getMonthlyVal(compareData, key, previousYear)
      compareValue = CurrentMonthMinusPreviousMonthAmount(compareCurrentValues, comparePreviousValues, true, ytdMonths)
    }
  } else if (getNormalYearKeys.includes(key)) {
    let currentValues = getMonthlyVal(youData, key, selectedYear)
    let ytdValues = getYTDMonths(currentValues, ytdMonths)
    youValue = ytdValues.reduce((a, b) => a + b, 0);

    if (comparePresent) {
      let compareCurrentValues = getMonthlyVal(compareData, key, compareFirstYear)
      let compareYTDValues = getYTDMonths(compareCurrentValues, ytdMonths)
      compareValue = compareYTDValues.reduce((a, b) => a + b, 0);
    }
  } else if (key === 'net_operating_activities') {
    youValue = netOperatingActivitiesValuesMonths(youData, selectedYear, previousYear, true, ytdMonths)
    if (comparePresent) {
      if (forecast) {
        compareValue = netOperatingActivitiesValuesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths, true, fallbackPrevYearData)
      } else {
        compareValue = netOperatingActivitiesValuesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths)
      }
    }
  } else if (key === 'net_investing_activities') {
    youValue = netInvestingActivitiesMonths(youData, selectedYear, previousYear, true, ytdMonths)
    if (comparePresent) {
      if (forecast) {
        compareValue = netInvestingActivitiesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths, true, fallbackPrevYearData)
      } else {
        compareValue = netInvestingActivitiesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths)
      }
    }
  } else if (key === 'equity') {
    youValue = equityMonths(youData, selectedYear, previousYear, true, ytdMonths)
    if (comparePresent) {
      if (forecast) {
        compareValue = equityMonths(compareData, compareFirstYear, previousYear, true, ytdMonths, true, fallbackPrevYearData)
      } else {
        compareValue = equityMonths(compareData, compareFirstYear, previousYear, true, ytdMonths)
      }
    }
  } else if (key === 'net_financing_activities') {
    youValue = netFinancingActivitiesValuesMonths(youData, selectedYear, previousYear, true, ytdMonths)
    if (comparePresent) {
      if (forecast) {
        compareValue = netFinancingActivitiesValuesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths, true, fallbackPrevYearData)
      } else {
        compareValue = netFinancingActivitiesValuesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths)
      }
    }
  } else if (key === 'net_change_cash') {
    let netOperatingActivities = netOperatingActivitiesValuesMonths(youData, selectedYear, previousYear, true, ytdMonths)
    let netInvestingActivities = netInvestingActivitiesMonths(youData, selectedYear, previousYear, true, ytdMonths)
    let netFinancingActivities = netFinancingActivitiesValuesMonths(youData, selectedYear, previousYear, true, ytdMonths)
    youValue = Math.round(netOperatingActivities + netInvestingActivities + netFinancingActivities, true)
    if (comparePresent) {
      if (forecast) {
        let netOperatingActivitiesCompare = netOperatingActivitiesValuesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths, true, fallbackPrevYearData)
        let netInvestingActivitiesCompare = netInvestingActivitiesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths, true, fallbackPrevYearData)
        let netFinancingActivitiesCompare = netFinancingActivitiesValuesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths, true, fallbackPrevYearData)
        compareValue = Math.round(netOperatingActivitiesCompare + netInvestingActivitiesCompare + netFinancingActivitiesCompare)
      } else {
        let netOperatingActivitiesCompare = netOperatingActivitiesValuesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths)
        let netInvestingActivitiesCompare = netInvestingActivitiesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths)
        let netFinancingActivitiesCompare = netFinancingActivitiesValuesMonths(compareData, compareFirstYear, previousYear, true, ytdMonths)
        compareValue = Math.round(netOperatingActivitiesCompare + netInvestingActivitiesCompare + netFinancingActivitiesCompare)
      }
    }
  } else if (key === 'cash_beginning_period') {
    let previousValues = getMonthlyVal(youData, 'cash', previousYear)
    youValue = _.isNumber(previousValues?.[12]) ? previousValues?.[12] : null;

    if (comparePresent) {
      let comparePreviousValues = forecast ? previousValues : getMonthlyVal(compareData, 'cash', previousYear)
      compareValue = _.isNumber(comparePreviousValues?.[12]) ? comparePreviousValues?.[12] : null
    }
  } else if (key === 'cash_end_period') {
    const getAllCashVals = getMonthlyVal(youData, 'cash', selectedYear)
    const lastValidYTDMonth = [...ytdMonths].reverse().find(m => _.isNumber(getAllCashVals?.[m]));
    const endCashYou = lastValidYTDMonth ? getAllCashVals[lastValidYTDMonth] : null;
    youValue = endCashYou;

    if (comparePresent) {
      const getAllCashValsCompare = getMonthlyVal(compareData, 'cash', compareFirstYear);
      const lastValidYTDMonthCompare = [...ytdMonths].reverse().find(m => _.isNumber(getAllCashValsCompare?.[m]));
      const endCashCompare = lastValidYTDMonthCompare ? getAllCashValsCompare[lastValidYTDMonthCompare] : null;
      compareValue = endCashCompare;
    }
  }
  return { youValue, compareValue }
}

// Monthly Cash Flow Values
const MonthlyCashFlowValues = (key, calcs, selectedYear, prevYear, compareCalcs, compareYear, prevCompareYear, isForecast = false) => {
  let getNormalYearKeys = ['operating_expenses_net_income', 'depreciation_and_amortization']
  let previousYearFirstKeys = ['accounts_receivable', 'inventory', 'under_billings', 'prepaid_and_other_current_assets', 'property_and_equipment', 'other_long_term_assets']
  let nextYearFirstKeys = ['accounts_payable', 'accrued_liabilities', 'over_billings', 'other_current_liabilities', 'line_of_credit', 'current_portion_of_ltd', 'long_term_debt']
  let youValues = null;
  let compareValues = null;
  // Comparison logic needs previous year values to do things like trailing calculations
  // So, for forecast data, you want to pull the previous year from the regular calcs object instead of expecting it to be in compareCalcs (forecastVals).
  let fallbackPrevYearData = isForecast ? calcs : null

  if (previousYearFirstKeys.includes(key)) {
    const currentMetric = calcs?.[key]?.[selectedYear] || {};
    const prevMetric = calcs?.[key]?.[prevYear] || {};
    youValues = PreviousMonthMinusCurrentMonthAmount(currentMetric, prevMetric)
    if (compareCalcs) {
      const currentCompareMetric = compareCalcs?.[key]?.[compareYear] || {};
      const prevCompareMetric = isForecast ? calcs?.[key]?.[prevCompareYear] || {} : compareCalcs?.[key]?.[prevCompareYear] || {};
      compareValues = PreviousMonthMinusCurrentMonthAmount(currentCompareMetric, prevCompareMetric)
    }
  } else if (nextYearFirstKeys.includes(key)) {
    const currentMetric = calcs?.[key]?.[selectedYear] || {};
    const prevMetric = calcs?.[key]?.[prevYear] || {};
    youValues = CurrentMonthMinusPreviousMonthAmount(currentMetric, prevMetric)
    if (compareCalcs) {
      const currentCompareMetric = compareCalcs?.[key]?.[compareYear] || {};
      const prevCompareMetric = isForecast ? calcs?.[key]?.[prevCompareYear] || {} : compareCalcs?.[key]?.[prevCompareYear] || {};
      compareValues = CurrentMonthMinusPreviousMonthAmount(currentCompareMetric, prevCompareMetric)
    }
  } else if (getNormalYearKeys.includes(key)) {
    youValues = calcs?.[key]?.[selectedYear] || {};
    if (compareCalcs) { compareValues = compareCalcs?.[key]?.[compareYear] || {}; }

  } else if (key === 'net_operating_activities') {
    youValues = netOperatingActivitiesValuesMonths(calcs, selectedYear, prevYear)
    if (compareCalcs) { compareValues = netOperatingActivitiesValuesMonths(compareCalcs, compareYear, prevCompareYear, false, [], isForecast, fallbackPrevYearData) }
  } else if (key === 'net_investing_activities') {
    youValues = netInvestingActivitiesMonths(calcs, selectedYear, prevYear)
    if (compareCalcs) { compareValues = netInvestingActivitiesMonths(compareCalcs, compareYear, prevCompareYear, false, [], isForecast, fallbackPrevYearData) }
  } else if (key === 'equity') {
    youValues = equityMonths(calcs, selectedYear, prevYear)
    if (compareCalcs) { compareValues = equityMonths(compareCalcs, compareYear, prevCompareYear, false, [], isForecast, fallbackPrevYearData) }
  } else if (key === 'net_financing_activities') {
    youValues = netFinancingActivitiesValuesMonths(calcs, selectedYear, prevYear)
    if (compareCalcs) { compareValues = netFinancingActivitiesValuesMonths(compareCalcs, compareYear, prevCompareYear, false, [], isForecast, fallbackPrevYearData) }
  } else if (key === 'net_change_cash') {
    let netOperatingActivities = netOperatingActivitiesValuesMonths(calcs, selectedYear, prevYear)
    let netInvestingActivities = netInvestingActivitiesMonths(calcs, selectedYear, prevYear)
    let netFinancingActivities = netFinancingActivitiesValuesMonths(calcs, selectedYear, prevYear)
    youValues = netChangeInCashValuesMonths(netOperatingActivities, netInvestingActivities, netFinancingActivities)
    if (compareCalcs) {
      let netOperatingActivitiesCompare = netOperatingActivitiesValuesMonths(compareCalcs, compareYear, prevCompareYear, false, [], isForecast, fallbackPrevYearData)
      let netInvestingActivitiesCompare = netInvestingActivitiesMonths(compareCalcs, compareYear, prevCompareYear, false, [], isForecast, fallbackPrevYearData)
      let netFinancingActivitiesCompare = netFinancingActivitiesValuesMonths(compareCalcs, compareYear, prevCompareYear, false, [], isForecast, fallbackPrevYearData)
      compareValues = netChangeInCashValuesMonths(netOperatingActivitiesCompare, netInvestingActivitiesCompare, netFinancingActivitiesCompare)
    }
  } else if (key === 'cash_beginning_period') {
    youValues = beginCashPeriodMonths(calcs, selectedYear, prevYear)
    if (compareCalcs) { compareValues = beginCashPeriodMonths(compareCalcs, compareYear, prevCompareYear, isForecast, fallbackPrevYearData) }

  } else if (key === 'cash_end_period') {
    youValues = calcs?.['cash']?.[selectedYear] || {};
    if (compareCalcs) {
      compareValues = compareCalcs?.['cash']?.[compareYear] || {};
    }
  }
  return { youValues, compareValues };
}

// Annual Cash Flow Values
const CashFlowCommonSizeArrows = (you, compare, key) => {
  // Common sized values
  let youVal = you * 100
  let compareVal = compare * 100
  const goodUpArrowKeys = ['operating_expenses_net_income', 'under_billings', 'prepaid_and_other_current_assets', 'property_and_equipment', 'other_long_term_assets', 'net_operating_activities', 'net_investing_activities', 'net_financing_activities', 'net_change_cash', 'cash', 'cash_beginning_period', 'cash_end_period', 'operating_cash_flow', 'capital_expenditure', 'free_cash_flow', 'equity'];
  let keyIsGoodUp = goodUpArrowKeys.includes(key)
  let rangeWorst = compareVal - 10;
  let rangeWorse = compareVal - 5
  let rangeBetter = compareVal + 5
  let rangeBest = compareVal + 10;

  if (rangeWorse < youVal && youVal < rangeBetter) {
    return 'maintain';
  } else if (rangeWorst < youVal && youVal < rangeWorse) {
    return keyIsGoodUp ? 'worse' : 'better';
  } else if (youVal < rangeWorst) {
    return keyIsGoodUp ? 'worst' : 'best';
  } else if (rangeBest > youVal && youVal > rangeBetter) {
    return keyIsGoodUp ? 'better' : 'worse';
  } else if (youVal > rangeBest) {
    return keyIsGoodUp ? 'best' : 'worst';
  } else {
    return 'n/a';
  }
}

const CashFlowYearAmounts = (years, you, avg, metric, subtract = '') => {
  const returnObject = {}
  const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
  const youTotalRevenue = you?.['total_revenue']
  const avgTotalRevenue = avgExists ? avg?.['total_revenue'] : null;
  let metricFinal = metric === 'cash_beginning_period' || metric === 'cash_end_period' ? 'cash' : metric;

  years.forEach((year) => {
    if (_.isNumber(you?.operating_expenses_net_income?.[year]) && you?.[metricFinal]) {
      // Check if previous year outside of yearRange exists
      let youPrevVal = you?.[metricFinal]?.[year - 1] || 0;
      let youCurrentVal = you?.[metricFinal]?.[year] || 0;
      if (years.indexOf(year) === 0 && subtract) {
        if (you[metricFinal][year - 1] !== null && subtract === 'previousYearMinusNextYear') {
          returnObject[year] = youPrevVal - youCurrentVal
          returnObject['you' + year] = (returnObject?.[year] / youTotalRevenue?.[year])
        } else if (you[metricFinal][year - 1] !== null && subtract === 'nextYearMinusPreviousYear') {
          returnObject[year] = youCurrentVal - youPrevVal
          returnObject['you' + year] = (returnObject?.[year] / youTotalRevenue?.[year])
        } else {
          returnObject[year] = null
          returnObject['you' + year] = null
        }
      } else if (subtract === 'previousYearMinusNextYear') {
        returnObject[year] = youPrevVal - youCurrentVal
        returnObject['you' + year] = (returnObject?.[year] / youTotalRevenue?.[year])
      } else if (subtract === 'nextYearMinusPreviousYear') {
        returnObject[year] = youCurrentVal - youPrevVal
        returnObject['you' + year] = (returnObject?.[year] / youTotalRevenue?.[year])
      } else {
        returnObject[year] = you[metricFinal][year]
        returnObject['you' + year] = (returnObject?.[year] / youTotalRevenue?.[year])
      }
    } else {
      returnObject[year] = null
      returnObject['you' + year] = null
    }

    if (avgExists && _.isNumber(avg?.operating_expenses_net_income?.[year])) {
      let avgPrevVal = avg?.[metricFinal]?.[year - 1] || 0
      let avgCurrentVal = avg?.[metricFinal]?.[year] || 0
      // Check if previous year outside of yearRange exists
      if (years.indexOf(year) === 0 && subtract) {
        if (avg?.[metricFinal]?.[year - 1] !== null && subtract === 'previousYearMinusNextYear') {
          returnObject['avgVal' + year] = avgPrevVal - avgCurrentVal
          returnObject['avg' + year] = (returnObject?.['avgVal' + year] / avgTotalRevenue?.[year])
        } else if (avg?.[metricFinal]?.[year - 1] !== null && subtract === 'nextYearMinusPreviousYear') {
          returnObject['avgVal' + year] = avgCurrentVal - avgPrevVal
          returnObject['avg' + year] = (returnObject?.['avgVal' + year] / avgTotalRevenue?.[year])
        } else {
          returnObject['avgVal' + year] = null
          returnObject['avg' + year] = null
        }
      } else if (subtract === 'previousYearMinusNextYear') {
        returnObject['avgVal' + year] = avgPrevVal - avgCurrentVal
        returnObject['avg' + year] = (returnObject?.['avgVal' + year] / avgTotalRevenue?.[year])
      } else if (subtract === 'nextYearMinusPreviousYear') {
        returnObject['avgVal' + year] = avgCurrentVal - avgPrevVal
        returnObject['avg' + year] = (returnObject?.['avgVal' + year] / avgTotalRevenue?.[year])
      } else {
        returnObject['avgVal' + year] = avg?.[metricFinal]?.[year]
        returnObject['avg' + year] = (returnObject?.['avgVal' + year] / avgTotalRevenue?.[year])
      }
    } else {
      returnObject['avgVal' + year] = null
      returnObject['avg' + year] = null
    }

    if (returnObject?.['you' + year] !== null && returnObject?.['avg' + year] !== null) {
      returnObject['status' + year] = CashFlowCommonSizeArrows(returnObject['you' + year], returnObject['avg' + year], metricFinal)
    } else {
      returnObject['status' + year] = 'n/a'
    }
  })
  return returnObject
}

const netOperatingActivitiesValues = (years, you, avg) => {
  const netOperatingActivities = {}
  const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
  const youTotalRevenue = you?.['total_revenue']
  const avgTotalRevenue = avgExists ? avg?.['total_revenue'] : null;
  let netIncome = CashFlowYearAmounts(years, you, avg, 'operating_expenses_net_income')
  let deprAmor = CashFlowYearAmounts(years, you, avg, 'depreciation_and_amortization')
  let accountsReceivable = CashFlowYearAmounts(years, you, avg, 'accounts_receivable', 'previousYearMinusNextYear')
  let inventory = CashFlowYearAmounts(years, you, avg, 'inventory', 'previousYearMinusNextYear')
  let underBillings = CashFlowYearAmounts(years, you, avg, 'under_billings', 'previousYearMinusNextYear')
  let prepaidOtherCurrentAssets = CashFlowYearAmounts(years, you, avg, 'prepaid_and_other_current_assets', 'previousYearMinusNextYear')
  let accountsPayable = CashFlowYearAmounts(years, you, avg, 'accounts_payable', 'nextYearMinusPreviousYear')
  let accruedLiabilities = CashFlowYearAmounts(years, you, avg, 'accrued_liabilities', 'nextYearMinusPreviousYear')
  let overBillings = CashFlowYearAmounts(years, you, avg, 'over_billings', 'nextYearMinusPreviousYear')
  let otherCurrentLiabilities = CashFlowYearAmounts(years, you, avg, 'other_current_liabilities', 'nextYearMinusPreviousYear')

  years.forEach((year) => {
    if (!netIncome[year] && !deprAmor[year] && !accountsReceivable[year] && !inventory[year] && !underBillings[year] && !prepaidOtherCurrentAssets[year] && !accountsPayable[year] && !accruedLiabilities[year] && !overBillings[year] && !otherCurrentLiabilities[year]) {
      netOperatingActivities[year] = null
    } else {
      netOperatingActivities[year] = Math.round(netIncome[year] + deprAmor[year] + accountsReceivable[year] + inventory[year] + underBillings[year] + prepaidOtherCurrentAssets[year] + accountsPayable[year] + accruedLiabilities[year] + overBillings[year] + otherCurrentLiabilities[year])
      netOperatingActivities['you' + year] = (netOperatingActivities[year] / youTotalRevenue[year])
    }

    if (!netIncome['avgVal' + year] && !deprAmor['avgVal' + year] && !accountsReceivable['avgVal' + year] && !inventory['avgVal' + year] && !underBillings['avgVal' + year] && !prepaidOtherCurrentAssets['avgVal' + year] && !accountsPayable['avgVal' + year] && !accruedLiabilities['avgVal' + year] && !overBillings['avgVal' + year] && !otherCurrentLiabilities['avgVal' + year]) {
      netOperatingActivities['avgVal' + year] = null
    } else {
      netOperatingActivities['avgVal' + year] = Math.round(netIncome['avgVal' + year] + deprAmor['avgVal' + year] + accountsReceivable['avgVal' + year] + inventory['avgVal' + year] + underBillings['avgVal' + year] + prepaidOtherCurrentAssets['avgVal' + year] + accountsPayable['avgVal' + year] + accruedLiabilities['avgVal' + year] + overBillings['avgVal' + year] + otherCurrentLiabilities['avgVal' + year])
      netOperatingActivities['avg' + year] = (netOperatingActivities['avgVal' + year] / avgTotalRevenue[year])
    }

    if (netOperatingActivities['you' + year] !== null && netOperatingActivities['avg' + year] !== null) {
      netOperatingActivities['status' + year] = CashFlowCommonSizeArrows(netOperatingActivities['you' + year], netOperatingActivities['avg' + year], 'net_operating_activities')
    } else {
      netOperatingActivities['status' + year] = 'n/a'
    }
  })
  return netOperatingActivities
}

const netInvestingActivitiesValues = (years, you, avg) => {
  const netInvestingActivities = {}
  const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
  const youTotalRevenue = you?.['total_revenue']
  const avgTotalRevenue = avgExists ? avg?.['total_revenue'] : null;
  let propEquip = CashFlowYearAmounts(years, you, avg, 'property_and_equipment', 'previousYearMinusNextYear')
  let otherLongTermAssets = CashFlowYearAmounts(years, you, avg, 'other_long_term_assets', 'previousYearMinusNextYear')
  years.forEach((year) => {
    if (propEquip[year] === null && otherLongTermAssets[year] === null) {
      netInvestingActivities[year] = null
    } else {
      netInvestingActivities[year] = Math.round(propEquip[year] + otherLongTermAssets[year])
      netInvestingActivities['you' + year] = (netInvestingActivities[year] / youTotalRevenue[year])
    }
    if (propEquip['avgVal' + year] === null && otherLongTermAssets['avgVal' + year] === null) {
      netInvestingActivities['avgVal' + year] = null
    } else {
      netInvestingActivities['avgVal' + year] = Math.round(propEquip['avgVal' + year] + otherLongTermAssets['avgVal' + year])
      netInvestingActivities['avg' + year] = (netInvestingActivities['avgVal' + year] / avgTotalRevenue[year])
    }

    if (netInvestingActivities['you' + year] !== null && netInvestingActivities['avg' + year] !== null) {
      netInvestingActivities['status' + year] = CashFlowCommonSizeArrows(netInvestingActivities['you' + year], netInvestingActivities['avg' + year], 'net_investing_activities')
    } else {
      netInvestingActivities['status' + year] = 'n/a'
    }
  })
  return netInvestingActivities
}

const netFinancingActivitiesValues = (years, you, avg) => {
  const netFinancingActivities = {}
  const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
  const youTotalRevenue = you?.['total_revenue']
  const avgTotalRevenue = avgExists ? avg?.['total_revenue'] : null;
  let lineOfCredit = CashFlowYearAmounts(years, you, avg, 'line_of_credit', 'nextYearMinusPreviousYear')
  let currentPortionOfLTD = CashFlowYearAmounts(years, you, avg, 'current_portion_of_ltd', 'nextYearMinusPreviousYear')
  let longTermDebt = CashFlowYearAmounts(years, you, avg, 'long_term_debt', 'nextYearMinusPreviousYear')
  let equity = createEquity(years, you, avg)
  years.forEach((year) => {
    if (lineOfCredit[year] === null && currentPortionOfLTD[year] === null && longTermDebt[year] === null && equity[year] === null) {
      netFinancingActivities[year] = null
    } else {
      netFinancingActivities[year] = Math.round(lineOfCredit[year] + currentPortionOfLTD[year] + longTermDebt[year] + equity[year])
      netFinancingActivities['you' + year] = (netFinancingActivities[year] / youTotalRevenue[year])
    }

    if (lineOfCredit['avgVal' + year] === null && currentPortionOfLTD['avgVal' + year] === null && longTermDebt['avgVal' + year] === null && equity['avgVal' + year] === null) {
      netFinancingActivities['avgVal' + year] = null
    } else {
      netFinancingActivities['avgVal' + year] = Math.round(lineOfCredit['avgVal' + year] + currentPortionOfLTD['avgVal' + year] + longTermDebt['avgVal' + year] + equity['avgVal' + year])
      netFinancingActivities['avg' + year] = (netFinancingActivities['avgVal' + year] / avgTotalRevenue[year])
    }

    if (netFinancingActivities['you' + year] !== null && netFinancingActivities['avg' + year] !== null) {
      netFinancingActivities['status' + year] = CashFlowCommonSizeArrows(netFinancingActivities['you' + year], netFinancingActivities['avg' + year], 'net_financing_activities')
    } else {
      netFinancingActivities['status' + year] = 'n/a'
    }
  })

  return netFinancingActivities
}

const netChangeInCashValues = (years, you, avg, netOperatingActivities, netInvestingActivities, netFinancingActivities) => {
  const netChangeInCash = {}
  const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
  const youTotalRevenue = you?.['total_revenue']
  const avgTotalRevenue = avgExists ? avg?.['total_revenue'] : null;
  years.forEach((year) => {
    if (netOperatingActivities[year] === null && netInvestingActivities[year] === null && netFinancingActivities[year] === null) {
      netChangeInCash[year] = null
    } else {
      netChangeInCash[year] = netOperatingActivities[year] + netInvestingActivities[year] + netFinancingActivities[year]
      netChangeInCash['you' + year] = (netChangeInCash[year] / youTotalRevenue[year])
    }

    if (netOperatingActivities['avgVal' + year] === null && netInvestingActivities['avgVal' + year] === null && netFinancingActivities['avgVal' + year] === null) {
      netChangeInCash['avgVal' + year] = null
    } else {
      netChangeInCash['avgVal' + year] = netOperatingActivities['avgVal' + year] + netInvestingActivities['avgVal' + year] + netFinancingActivities['avgVal' + year]
      netChangeInCash['avg' + year] = (netChangeInCash['avgVal' + year] / avgTotalRevenue[year])
    }

    if (netChangeInCash['you' + year] !== null && netChangeInCash['avg' + year] !== null) {
      netChangeInCash['status' + year] = CashFlowCommonSizeArrows(netChangeInCash['you' + year], netChangeInCash['avg' + year], 'net_change_cash')
    } else {
      netChangeInCash['status' + year] = 'n/a'
    }
  })

  return netChangeInCash
}

const createEquity = (years, you, avg) => {
  const returnObject = {}
  const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
  const youTotalRevenue = you?.['total_revenue']
  const avgTotalRevenue = avgExists ? avg?.['total_revenue'] : null;
  years.forEach(year => {
    if (you?.['operating_expenses_net_income']?.[year] && you?.['net_worth']?.[year]) {
      if (you?.['net_worth']?.[year - 1]) {
        returnObject[year] = you['net_worth'][year] - you['operating_expenses_net_income'][year] - you['net_worth'][year - 1]
        returnObject['you' + year] = (returnObject[year] / youTotalRevenue[year])
      } else {
        returnObject[year] = null
        returnObject['you' + year] = null
      }
    } else {
      returnObject[year] = null
    }

    if (avgExists && you?.['operating_expenses_net_income']?.[year] && you?.['net_worth']?.[year]) {
      if (avg?.['net_worth']?.[year - 1]) {
        returnObject['avgVal' + year] = avg['net_worth'][year] - avg['operating_expenses_net_income'][year] - avg['net_worth'][year - 1]
        returnObject['avg' + year] = (returnObject['avgVal' + year] / avgTotalRevenue[year])
      } else {
        returnObject['avgVal' + year] = null
        returnObject['avg' + year] = null
      }
    } else {
      returnObject['avgVal' + year] = null
    }

    if (returnObject?.['you' + year] && returnObject?.['avg' + year]) {
      returnObject['status' + year] = CashFlowCommonSizeArrows(returnObject['you' + year], returnObject['avg' + year], 'equity')
    } else {
      returnObject['status' + year] = 'n/a'
    }
  })
  return returnObject
}

const createBeginCashPeriod = (years, you, avg) => {
  const cashAtBeginning = {}
  const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
  const youTotalRevenue = you?.['total_revenue']
  const avgTotalRevenue = avgExists ? avg?.['total_revenue'] : null;
  if (you) {
    years.forEach((year) => {
      // Don't want to show beginning cash for previous year outside of yearRange that we don't have data for
      if (years.indexOf(year) === 0) {
        if (you?.cash?.[year - 1]) {
          cashAtBeginning[year] = you.cash[year - 1]
          cashAtBeginning['you' + year] = (cashAtBeginning[year] / youTotalRevenue[year])
        } else {
          cashAtBeginning[year] = null
          cashAtBeginning['you' + year] = null
        }
  
        if (avgExists && avg?.cash?.[year - 1]) {
          cashAtBeginning['avgVal' + year] = avg.cash[year - 1]
          cashAtBeginning['avg' + year] = (cashAtBeginning['avgVal' + year] / avgTotalRevenue[year])
        } else {
          cashAtBeginning['avgVal' + year] = null
          cashAtBeginning['avg' + year] = null
        }
      } else {
        cashAtBeginning[year] = you?.cash?.[year - 1]
        cashAtBeginning['avgVal' + year] = avgExists ? avg?.cash?.[year - 1] : null;
        cashAtBeginning['you' + year] = (cashAtBeginning[year] / youTotalRevenue[year])
        cashAtBeginning['avg' + year] = avgExists ? (cashAtBeginning['avgVal' + year] / avgTotalRevenue[year]) : null;
      }
  
      if (cashAtBeginning?.['you' + year] && cashAtBeginning?.['avg' + year]) {
        cashAtBeginning['status' + year] = CashFlowCommonSizeArrows(cashAtBeginning['you' + year], cashAtBeginning['avg' + year], 'cash')
      } else {
        cashAtBeginning['status' + year] = 'n/a'
      }
    })
  }
  return cashAtBeginning;
}

const freeCashFlowValues = (years, you, avg, operatingCashFlow) => {
  // Capital Expenditure uses same percentages from Property & Equipment
  const freeCashFlow = {}
  let capitalExpenditure = CashFlowYearAmounts(years, you, avg, 'property_and_equipment', 'previousYearMinusNextYear')
  years.forEach((year) => {
    freeCashFlow['you' + year] = capitalExpenditure['you' + year] + operatingCashFlow['you' + year]
    freeCashFlow['avg' + year] = avg ? capitalExpenditure['avg' + year] + operatingCashFlow['avg' + year] : null
    if (freeCashFlow['you' + year] !== null && freeCashFlow['avg' + year] !== null) {
      freeCashFlow['status' + year] = CashFlowCommonSizeArrows(freeCashFlow['you' + year], freeCashFlow['avg' + year], 'free_cash_flow')
    } else {
      freeCashFlow['status' + year] = 'n/a'
    }
  })
  return freeCashFlow
}

const AnnualCashFlowValues = (calcs, aggregateCalcs, calcsAvgType, years, key) => {
  const you = calcs.you;
  const avg = calcsAvgType && aggregateCalcs ? aggregateCalcs?.[calcsAvgType] : null;
  let row;
  let getNormalYearKeys = ['operating_expenses_net_income', 'depreciation_and_amortization']
  let previousYearFirstKeys = ['accounts_receivable', 'inventory', 'under_billings', 'prepaid_and_other_current_assets', 'property_and_equipment', 'other_long_term_assets', 'capital_expenditure']
  let nextYearFirstKeys = ['accounts_payable', 'accrued_liabilities', 'over_billings', 'other_current_liabilities', 'line_of_credit', 'current_portion_of_ltd', 'long_term_debt']

  if (previousYearFirstKeys.includes(key)) {
    // no values for capital expenditure but it is the same as property and equipment
    if (key === 'capital_expenditure') {
      row = CashFlowYearAmounts(years, you, avg, 'property_and_equipment', 'previousYearMinusNextYear')
    } else {
      row = CashFlowYearAmounts(years, you, avg, key, 'previousYearMinusNextYear')
    }
  } else if (nextYearFirstKeys.includes(key)) {
    row = CashFlowYearAmounts(years, you, avg, key, 'nextYearMinusPreviousYear')
  } else if (getNormalYearKeys.includes(key) || key === 'cash_end_period') {
    row = CashFlowYearAmounts(years, you, avg, key)
  } else if (key === 'net_operating_activities' || key === 'operating_cash_flow') {
    row = netOperatingActivitiesValues(years, you, avg)
  } else if (key === 'net_investing_activities') {
    row = netInvestingActivitiesValues(years, you, avg)
  } else if (key === 'equity') {
    row = createEquity(years, you, avg)
  } else if (key === 'net_financing_activities') {
    row = netFinancingActivitiesValues(years, you, avg)
  } else if (key === 'net_change_cash') {
    let netOperatingActivities = netOperatingActivitiesValues(years, you, avg)
    let netInvestingActivities = netInvestingActivitiesValues(years, you, avg)
    let netFinancingActivities = netFinancingActivitiesValues(years, you, avg)
    row = netChangeInCashValues(years, you, avg, netOperatingActivities, netInvestingActivities, netFinancingActivities)
  } else if (key === 'cash_beginning_period') {
    row = createBeginCashPeriod(years, you, avg)
  } else if (key === 'free_cash_flow') {
    let operatingCashFlow = netOperatingActivitiesValues(years, you, avg)
    row = freeCashFlowValues(years, you, avg, operatingCashFlow)
  }
  return row;
}

// Annual KFI's
const KFIsCommonSizeArrows = (you, avg, key, parentKey) => {
  let youVal = you
  let avgVal = avg
  let rangeWorst, rangeWorse, rangeBetter, rangeBest;
  const percentKeys = ['total_revenue_growth_rate', 'cash_flow_margin', 'roa', 'roe', 'roce', 'gross_profit', 'operating_profit', 'net_profit', 'gross_profit_common_size_revenue', 'operating_profit_common_size_revenue', 'operating_expenses_net_income_common_size_revenue']
  if (percentKeys.includes(key) && youVal) {
    youVal = you * 100
  }
  if (percentKeys.includes(key) && avgVal) {
    avgVal = avg * 100
  }
  // Only ar_days, debt_to_equity are good with lower values than peers avg
  const goodDownArrowKeys = ['debt_ratio', 'ar_days', 'debt_to_equity', 'maintenace_per_golf_hole'];
  const keyIsGoodDown = goodDownArrowKeys.includes(key);
  const ignoreArrowKeys = ['ebitda'];
  if (ignoreArrowKeys.includes(key) || ignoreArrowKeys.includes(parentKey) || !youVal || !avgVal) {
    return 'maintain'
  }

  if (key === 'debt_to_equity' && youVal < 0) {
    return 'worse'
  }

  if (!percentKeys.includes(key) && avgVal) {
    let fivePercent = avgVal * 0.05
    let tenPercent = avgVal * 0.1
    rangeWorst = avgVal - tenPercent;
    rangeWorse = avgVal - fivePercent;
    rangeBetter = avgVal + fivePercent;
    rangeBest = avgVal + tenPercent;
  } else {
    rangeWorst = avgVal - 10;
    rangeWorse = avgVal - 5;
    rangeBetter = avgVal + 5;
    rangeBest = avgVal + 10;
  }

  if (rangeWorse < youVal && youVal < rangeBetter) {
    return 'maintain'
  } else if (rangeWorst < youVal && youVal < rangeWorse) {
    return keyIsGoodDown ? 'better' : 'worse'
  } else if (youVal < rangeWorst) {
    return keyIsGoodDown ? 'best' : 'worst'
  } else if (rangeBest > youVal && youVal > rangeBetter) {
    return keyIsGoodDown ? 'worse' : 'better'
  } else if (youVal > rangeBest) {
    return keyIsGoodDown ? 'worst' : 'best'
  } else {
    return 'n/a'
  }
}

const calculateNetWorkingCapitalYears = (years, you, avg) => {
  const returnObject = {}
  const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
  // Need to common size compare with you total_assets
  const youTotalAssets = you?.['total_assets'];
  const youTotalCurrentAssets = you?.['total_current_assets'];
  const youTotalCurrentLiabilities = you?.['total_current_liabilities'];
  const avgTotalCurrentAssetsCommonSize = avgExists ? avg?.['total_current_assets_common_size_assets'] : null;
  const avgTotalCurrentLiabilitiesCommonSize = avgExists ? avg?.['total_current_liabilities_common_size_assets'] : null;
  years.forEach((y) => {
    if (_.isNumber(youTotalCurrentAssets?.[y]) && _.isNumber(youTotalCurrentLiabilities?.[y])) {
      returnObject[y] = youTotalCurrentAssets[y] - youTotalCurrentLiabilities[y];
    } else {
      returnObject[y] = null;
    }

    if (avgExists && _.isNumber(avgTotalCurrentAssetsCommonSize?.[y]) && _.isNumber(avgTotalCurrentLiabilitiesCommonSize?.[y])) {
      returnObject['avg' + y] = (avgTotalCurrentAssetsCommonSize[y] * youTotalAssets[y]) - (avgTotalCurrentLiabilitiesCommonSize[y] * youTotalAssets[y]);
    } else {
      returnObject['avg' + y] = null;
    }

    returnObject['status' + y] = KFIsCommonSizeArrows(returnObject[y], returnObject['avg' + y], 'net_working_capital')

  })

  return returnObject;
}

// Need to calculate the ebitda correctly with taxes for you and avg values and calulations that use it
const calculateEBITDAYears = (years, you, avg) => {
  let ebitda = {}
  if (you) {
    // Need to common size compare with you total_assets
    const youTotalRevenue = you?.['total_revenue'];
    const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
    const youNetIncome = you?.['operating_expenses_net_income'];
    const youInterest = you?.['interest_and_other_expenses'];
    const youTaxesFS = you?.['total_other_costs_taxes_- federal & state'];
    const youDeprAmor = you?.['depreciation_and_amortization'];
    const avgNetIncomeCS = avgExists ? avg['operating_expenses_net_income_common_size_revenue'] : null;
    const avgInterestCS = avgExists ? avg['interest_and_other_expenses_common_size_revenue'] : null;
    const avgTaxesFSCS = avgExists ? avg['total_other_costs_taxes_- federal & state_common_size_revenue'] : null;
    const avgDeprAmorCS = avgExists ? avg['depreciation_and_amortization_common_size_revenue'] : null;
  
    years.forEach((y) => {
      let youNetIncomeVal = youNetIncome && _.isNumber(youNetIncome[y]) ? youNetIncome[y] : null
      let youInterestVal = youInterest && _.isNumber(youInterest[y]) ? youInterest[y] : null
      let youTaxesFSVal = youTaxesFS && _.isNumber(youTaxesFS[y]) ? youTaxesFS[y] : null;
      let youDeprAmorVal = youDeprAmor && _.isNumber(youDeprAmor[y]) ? youDeprAmor[y] : null
      ebitda[y] = youNetIncomeVal + youInterestVal + youTaxesFSVal + youDeprAmorVal;
  
      if (avgExists) {
        let avgNetIncomeVal = avgNetIncomeCS && _.isNumber(avgNetIncomeCS[y]) ? avgNetIncomeCS[y] * youTotalRevenue[y] : null
        let avgInterestVal = avgInterestCS && _.isNumber(avgInterestCS[y]) ? avgInterestCS[y] * youTotalRevenue[y] : null
        let avgTaxesFSVal = avgTaxesFSCS && _.isNumber(avgTaxesFSCS[y]) ? avgTaxesFSCS[y] * youTotalRevenue[y] : null;
        let avgDeprAmorVal = avgDeprAmorCS && _.isNumber(avgDeprAmorCS[y]) ? avgDeprAmorCS[y] * youTotalRevenue[y] : null
        ebitda['avg' + y] = avgNetIncomeVal + avgInterestVal + avgTaxesFSVal + avgDeprAmorVal;
      } else {
        ebitda['avg' + y] = null;
      }
  
      ebitda['status' + y] = KFIsCommonSizeArrows(ebitda[y], ebitda['avg' + y], 'ebitda')
    })
  }
  return ebitda;
}

const calculateSeniorDebtToEBITDAYears = (years, you, avg) => {
  let seniorDebtToEBITDA = {}
  if (you) {
    let ebitda = calculateEBITDAYears(years, you, avg);
    const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
    const youLongTermDebt = you?.['long_term_debt'];
    const youLineOfCredit = you?.['line_of_credit'];
    const youCurrentPortionOfLTD = you?.['current_portion_of_ltd'];
    const avgLongTermDebt = avgExists ? avg?.['long_term_debt'] : null;
    const avgLineOfCredit = avgExists ? avg?.['line_of_credit'] : null;
    const avgCurrentPortionOfLTD = avgExists ? avg?.['current_portion_of_ltd'] : null;
  
    years.forEach((y) => {
      if (ebitda[y]) {
        seniorDebtToEBITDA[y] = (youLongTermDebt[y] + youLineOfCredit[y] + youCurrentPortionOfLTD[y]) / ebitda[y]
      } else {
        seniorDebtToEBITDA[y] = null;
      }
  
      if (avgExists && ebitda['avg' + y]) {
        seniorDebtToEBITDA['avg' + y] = (avgLongTermDebt[y] + avgLineOfCredit[y] + avgCurrentPortionOfLTD[y]) / ebitda['avg' + y]
      } else {
        seniorDebtToEBITDA['avg' + y] = null;
      }
  
      seniorDebtToEBITDA['status' + y] = KFIsCommonSizeArrows(seniorDebtToEBITDA[y], seniorDebtToEBITDA['avg' + y], 'senior_debt_to_ebitda')
  
    })
  }
  return seniorDebtToEBITDA;
}

const calculateEBITDAtoAnnualInterestYears = (years, you, avg) => {
  let ebitdaToAnnualInterest = {}

  if (you) {
    let ebitda = calculateEBITDAYears(years, you, avg);
    const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
    const youInterest = you?.['interest_and_other_expenses'];
    const avgInterest = avgExists ? avg?.['interest_and_other_expenses'] : null;
    years.forEach((y) => {
      if (youInterest[y]) {
        ebitdaToAnnualInterest[y] = ebitda[y] / youInterest[y]
      } else {
        ebitdaToAnnualInterest[y] = null;
      }
  
      if (avgExists && avgInterest[y]) {
        ebitdaToAnnualInterest['avg' + y] = ebitda['avg' + y] / avgInterest[y]
      } else {
        ebitdaToAnnualInterest['avg' + y] = null;
      }
  
      ebitdaToAnnualInterest['status' + y] = KFIsCommonSizeArrows(ebitdaToAnnualInterest[y], ebitdaToAnnualInterest['avg' + y], 'ebitda_to_annual_interest')
    })
  }
  return ebitdaToAnnualInterest
}

const calcDaysCashOnHandYears = (years, you, avg) => {
  // Cash / ((Total Operating Expenses + Interest & Other Expense + Taxes - Federal & State + Other (Income) Expense) / 365)
  let daysCashOnHand = {}
  if (you) {
    const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
    const youOpEx = you?.['total_operating_expenses'];
    const avgOpEx = avgExists ? avg?.['total_operating_expenses'] : null;
  
    years.forEach((y) => {
      if (youOpEx?.[y]) {
        daysCashOnHand[y] = you?.['cash']?.[y] / ((youOpEx[y] + you?.['interest_and_other_expenses']?.[y] + you?.['total_other_costs_taxes_- federal & state']?.[y] + you?.['other_income_expenses']?.[y]) / 365)
      } else {
        daysCashOnHand[y] = null;
      }
  
      if (avgExists && avgOpEx?.[y]) {
        daysCashOnHand['avg' + y] = avg?.['cash']?.[y] / ((avgOpEx[y] + avg?.['interest_and_other_expenses']?.[y] + avg?.['total_other_costs_taxes_- federal & state']?.[y] + avg?.['other_income_expenses']?.[y]) / 365)
      } else {
        daysCashOnHand['avg' + y] = null;
      }
  
      daysCashOnHand['status' + y] = KFIsCommonSizeArrows(daysCashOnHand[y], daysCashOnHand['avg' + y], 'days_cash_on_hand')
    })
  }
  return daysCashOnHand
}

const calcQuickRatioYears = (years, you, avg) => {
  // (Current Assets - Inventory)/Current Liabilities
  let quickRatio = {}
  if (you) {
    const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
    const youCL = you?.['total_current_liabilities'];
    const avgCL = avgExists ? avg?.['total_current_liabilities'] : null;
  
    years.forEach((y) => {
      if (youCL?.[y]) {
        quickRatio[y] = (you?.['total_current_assets']?.[y] - you?.['inventory']?.[y]) / youCL[y]
      } else {
        quickRatio[y] = null;
      }
  
      if (avgExists && avgCL?.[y]) {
        quickRatio['avg' + y] = (avg?.['total_current_assets']?.[y] - avg?.['inventory']?.[y]) / avgCL[y]
      } else {
        quickRatio['avg' + y] = null;
      }
  
      quickRatio['status' + y] = KFIsCommonSizeArrows(quickRatio[y], quickRatio['avg' + y], 'quick_ratio')
    })
  }
  return quickRatio
}

const calcDebtRatioYears = (years, you, avg) => {
  // (Total Current Liabilities + Long Term Debt) / Total Aassets
  let debtRatio = {}
  if (you) {
    const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
    const youTA = you?.['total_assets'];
    const avgTA = avgExists ? avg?.['total_assets'] : null;
  
    years.forEach((y) => {
      if (youTA?.[y]) {
        debtRatio[y] = (you?.['total_current_liabilities']?.[y] + you?.['long_term_debt']?.[y]) / youTA[y]
      } else {
        debtRatio[y] = null;
      }
  
      if (avgExists && avgTA?.[y]) {
        debtRatio['avg' + y] = (avg?.['total_current_liabilities']?.[y] + avg?.['long_term_debt']?.[y]) / avgTA[y]
      } else {
        debtRatio['avg' + y] = null;
      }
  
      debtRatio['status' + y] = KFIsCommonSizeArrows(debtRatio[y], debtRatio['avg' + y], 'debt_ratio')
    })
  }
  return debtRatio
}

const calcOperatingCashFlowYears = (years, you, avg) => {
  // 	Net cash flow from operating activities / Current Liabilities
  let operatingCashFlow = {}
  if (you) {
    const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
    const youCL = you?.['total_current_liabilities'];
    const avgCL = avgExists ? avg?.['total_current_liabilities'] : null;
    const opCashFLow = netOperatingActivitiesValues(years, you, avg)
  
    years.forEach((y) => {
      if (youCL?.[y]) {
        operatingCashFlow[y] = opCashFLow[y] / youCL[y]
      } else {
        operatingCashFlow[y] = null;
      }
  
      if (avgExists && avgCL?.[y]) {
        operatingCashFlow['avg' + y] = opCashFLow['avgVal' + y] / avgCL[y]
      } else {
        operatingCashFlow['avg' + y] = null;
      }
  
      operatingCashFlow['status' + y] = KFIsCommonSizeArrows(operatingCashFlow[y], operatingCashFlow['avg' + y], 'operating_cash_flow_kfi')
    })
  }
  return operatingCashFlow
}

const calcCashFlowMarginYears = (years, you, avg) => {
  // 	Net cash flow from operating activities / Net Revenue (Total Revenue)
  let cashFlowMargin = {}
  if (you) {
    const avgExists = avg && Object.keys(avg).length > 0 ? true : false;
    const youTR = you?.['total_revenue'];
    const avgTR = avgExists ? avg?.['total_revenue'] : null;
    const opCashFLow = netOperatingActivitiesValues(years, you, avg)
  
    years.forEach((y) => {
      if (youTR?.[y]) {
        cashFlowMargin[y] = opCashFLow[y] / youTR[y]
      } else {
        cashFlowMargin[y] = null;
      }
  
      if (avgExists && avgTR?.[y]) {
        cashFlowMargin['avg' + y] = opCashFLow['avgVal' + y] / avgTR[y]
      } else {
        cashFlowMargin['avg' + y] = null;
      }
  
      cashFlowMargin['status' + y] = KFIsCommonSizeArrows(cashFlowMargin[y], cashFlowMargin['avg' + y], 'cash_flow_margin')
    })
  }
  return cashFlowMargin
}

const AnnualKFIsValues = (calcs, aggregateCalcs, calcsAvgType = 'avg', years, key, report = 'money') => {
  const you = report === 'money' ? calcs.you : calcs.avg;
  const avg = calcsAvgType && aggregateCalcs ? aggregateCalcs?.[calcsAvgType] : null;
  let row;
  const avgExists = avg && Object.keys(avg).length > 0 ? true : false;

  if (key === 'net_working_capital') {
    row = calculateNetWorkingCapitalYears(years, you, avg)
  } else if (key === 'ebitda') {
    row = calculateEBITDAYears(years, you, avg)
  } else if (key === 'senior_debt_to_ebitda') {
    row = calculateSeniorDebtToEBITDAYears(years, you, avg)
  } else if (key === 'ebitda_to_annual_interest') {
    row = calculateEBITDAtoAnnualInterestYears(years, you, avg)
  } else if (key === 'days_cash_on_hand') {
    row = calcDaysCashOnHandYears(years, you, avg)
  } else if (key === 'quick_ratio') {
    row = calcQuickRatioYears(years, you, avg)
  } else if (key === 'debt_ratio') {
    row = calcDebtRatioYears(years, you, avg)
  } else if (key === 'operating_cash_flow_kfi') {
    row = calcOperatingCashFlowYears(years, you, avg)
  } else if (key === 'cash_flow_margin') {
    row = calcCashFlowMarginYears(years, you, avg)
  } else if (key === 'maintenace_per_golf_hole') {
    let yearVals = {};
    years.forEach(y => {
      yearVals[y] = _.isNumber(you?.['total_operations_ops_- golf']) && _.isNumber(you?.['number_of_holes_on_golf_course']) ? (you?.['total_operations_ops_- golf']?.[y] / you?.['number_of_holes_on_golf_course']?.[y]) : null;;
      yearVals['avg' + y] = avgExists && _.isNumber(avg['total_operations_ops_- golf']) && _.isNumber(avg['number_of_holes_on_golf_course']) ? (avg['total_operations_ops_- golf'][y] / avg['number_of_holes_on_golf_course'][y]) : null;
      yearVals['status'] = KFIsCommonSizeArrows(yearVals[y], yearVals['avg' + y], 'maintenace_per_golf_hole')
    })
    row = yearVals;
  } else if (['operating_expenses_net_income', 'interest_and_other_expenses', 'total_other_costs_taxes_- federal & state', 'depreciation_and_amortization'].includes(key)) {
    let youTotalRevenue = you?.['total_revenue']
    let youVals = you?.[key] ? you[key] : null;
    let compareKey = key + '_common_size_revenue'
    let avgVals = avgExists && avg?.[compareKey] ? avg[compareKey] : null;
    let yearVals = {};

    if (youVals || avgVals) {
      years.forEach(y => {
        yearVals[y] = youVals && _.isNumber(youVals[y]) ? youVals[y] : null;
        yearVals['avg' + y] = avgExists && avgVals && _.isNumber(avgVals[y]) ? avgVals[y] * youTotalRevenue[y] : null;
        yearVals['status' + y] = KFIsCommonSizeArrows(yearVals[y], yearVals['avg' + y], key)
      })
    }
    row = yearVals;
  } else {
    let finalKey = key
    if (key === 'gross_profit') {
      finalKey = 'gross_profit_common_size_revenue'
    } else if (key === 'operating_profit') {
      finalKey = 'operating_profit_common_size_revenue'
    } else if (key === 'net_profit') {
      finalKey = 'operating_expenses_net_income_common_size_revenue'
    }

    let youVals = you?.[finalKey] ? you[finalKey] : null;
    let avgVals = avgExists && avg?.[finalKey] ? avg[finalKey] : null;
    let yearVals = {};

    if (youVals || avgVals) {
      years.forEach(y => {
        yearVals[y] = youVals && _.isNumber(youVals[y]) ? youVals[y] : null;
        yearVals['avg' + y] = avgExists && avgVals && _.isNumber(avgVals[y]) ? avgVals[y] : null;
        yearVals['status' + y] = KFIsCommonSizeArrows(yearVals[y], yearVals['avg' + y], finalKey)
      })
    }

    row = yearVals;
  }
  return row;
}

const monthlyNetProfit = (calcs, year, numberOfMonths) => {
  const netProfit = {}
  const netIncome = calcs?.['operating_expenses_net_income']?.[year] || {}
  const revenue = calcs?.['total_revenue']?.[year] || {}

  for (let i = 1; i <= numberOfMonths; i++) {
    let numerator = netIncome[i] ?? 0
    let denominator = revenue[i] ?? 0

    if (denominator !== 0) {
      netProfit[i] = (numerator / denominator)
    } else {
      netProfit[i] = null
    }
  }

  return netProfit
}

const monthlyDaysCashOnHand = (calcs, year, numberOfMonths) => {
  const daysCashOnHand = {}
  const cash = calcs?.['cash']?.[year] || {}
  const totalOpEx = calcs?.['total_operating_expenses']?.[year] || {}
  const interest = calcs?.['interest_and_other_expenses']?.[year] || {}
  const taxes = calcs?.['total_other_costs_taxes_- federal & state']?.[year] || {}
  const otherExpenses = calcs?.['other_income_expenses']?.[year] || {}

  for (let i = 1; i <= numberOfMonths; i++) {
    const numerator = cash[i] ?? null
    const denomOperating = totalOpEx[i] ?? null
    const denomInterest = interest[i] ?? 0
    const denomTaxes = taxes[i] ?? 0
    const denomOther = otherExpenses[i] ?? 0

    if (denomOperating !== null) {
      const denominator = denomOperating + denomInterest + denomTaxes + denomOther
      daysCashOnHand[i] = denominator !== 0 ? numerator / (denominator / 365) : null
    } else {
      daysCashOnHand[i] = null
    }
  }

  return daysCashOnHand
}

const monthlyQuickRatio = (calcs, year, numberOfMonths) => {
  const quickRatio = {}
  const currentAssets = calcs?.['total_current_assets']?.[year] || {}
  const currentLiabilities = calcs?.['total_current_liabilities']?.[year] || {}
  const inventory = calcs?.['inventory']?.[year] || {}

  for (let i = 1; i <= numberOfMonths; i++) {
    const denom = currentLiabilities[i] ?? null
    const assets = currentAssets[i] ?? null
    const inventoryVal = inventory[i] ?? 0

    if (denom !== null && assets !== null) {
      quickRatio[i] = (assets - inventoryVal) / denom
    } else {
      quickRatio[i] = null
    }
  }

  return quickRatio
}

const monthlyDebtRatio = (calcs, year, numberOfMonths) => {
  const debtRatio = {}
  const totalAssets = calcs?.['total_assets']?.[year] || {}
  const currentLiabilities = calcs?.['total_current_liabilities']?.[year] || {}
  const longTermDebt = calcs?.['long_term_debt']?.[year] || {}

  for (let i = 1; i <= numberOfMonths; i++) {
    const denom = totalAssets[i] ?? null
    const currLiabilities = currentLiabilities[i] ?? 0
    const ltd = longTermDebt[i] ?? 0

    if (denom !== null && denom !== 0) {
      debtRatio[i] = (currLiabilities + ltd) / denom
    } else {
      debtRatio[i] = null
    }
  }

  return debtRatio
}

const monthlyOperatingCashFlow = (key, calcs, year, prevYear, numberOfMonths, isForecast = false, fallbackPrevYearData = null) => {
  const opCashFlowMetric = {}
  // Net cash flow from operating activities
  const netOperatingActivities = netOperatingActivitiesValuesMonths(calcs, year, prevYear, false, [], isForecast, fallbackPrevYearData)
  const totalRevenue = calcs?.['total_revenue']?.[year] || {}
  const currentLiabilities = calcs?.['total_current_liabilities']?.[year] || {}

  for (let i = 1; i <= numberOfMonths; i++) {
    const numerator = netOperatingActivities[i] ?? null
    const denominator = key === 'operating_cash_flow_kfi'
      ? currentLiabilities[i] ?? null
      : totalRevenue[i] ?? null

    if (numerator !== null && denominator !== null && denominator !== 0) {
      opCashFlowMetric[i] = numerator / denominator
    } else {
      opCashFlowMetric[i] = null
    }
  }

  return opCashFlowMetric
}

// Monthly KFIs
const MonthlyKFIsValues = (row, numberOfMonths, compareWith, year, previousYear, twoYearsAgo, calcs, calcsPeers, isForecast = false, forecastVals = null) => {
  let youValues = null;
  let compareValues = null;
  let ytdYou = null;
  let ytdCompare = null;
  let fallbackPrevYearData = isForecast ? calcs : null

  const trailing12MonthsKeys = ['roa', 'roe', 'roce', 'asset_turnover_ratio', 'inventory_turnover_ratio', 'ar_days', 'ap_days', 'senior_debt_to_ebitda', 'ebitda_to_annual_interest', 'debt_to_equity'];
  const ebitdaKeys = ['operating_expenses_net_income', 'interest_and_other_expenses', 'total_other_costs_taxes_- federal & state', 'depreciation_and_amortization']
  let compareSelectedYear = year
  if (compareWith && compareWith.includes('Forecast')) {
    compareSelectedYear = forecastVals?.['total_revenue'] ? Object.keys(forecastVals['total_revenue'])[0] : null
  }

  if (row.key === 'total_revenue_growth_rate') {
    youValues = monthlyTotalRevenueGRCalc(calcs, year)

    if (compareWith === 'Default:YOY') {
      compareValues = monthlyTotalRevenueGRCalc(calcs, previousYear)
    } else if (compareWith === 'Default:Peers') {
      compareValues = monthlyTotalRevenueGRCalc(calcsPeers, year)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = monthlyTotalRevenueGRCalc(forecastVals, compareSelectedYear)
    }

    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;
  } else if (row.key === 'current_ratio') {
    youValues = ratioCalculations('total_current_assets', calcs, year)

    if (compareWith === 'Default:YOY') {
      compareValues = ratioCalculations('total_current_assets', calcs, previousYear)
    } else if (compareWith === 'Default:Peers') {
      compareValues = ratioCalculations('total_current_assets', calcsPeers, year)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = ratioCalculations('total_current_assets', forecastVals, compareSelectedYear)
    }
    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;
  } else if (row.key === 'gross_profit') {
    youValues = ratioCalculationsMoney('gross_profit', calcs, year, previousYear, numberOfMonths)

    if (compareWith === 'Default:YOY') {
      compareValues = ratioCalculationsMoney('gross_profit', calcs, previousYear, twoYearsAgo, numberOfMonths)
    } else if (compareWith === 'Default:Peers') {
      compareValues = ratioCalculationsMoney('gross_profit', calcsPeers, year, previousYear, numberOfMonths)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = ratioCalculationsMoney('gross_profit', forecastVals, compareSelectedYear, previousYear, numberOfMonths, isForecast, fallbackPrevYearData)
    }
    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;
  } else if (row.key === 'operating_profit') {
    youValues = ratioCalculationsMoney('operating_profit', calcs, year, previousYear, numberOfMonths)

    if (compareWith === 'Default:YOY') {
      compareValues = ratioCalculationsMoney('operating_profit', calcs, previousYear, twoYearsAgo, numberOfMonths)
    } else if (compareWith === 'Default:Peers') {
      compareValues = ratioCalculationsMoney('operating_profit', calcsPeers, year, previousYear, numberOfMonths)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = ratioCalculationsMoney('operating_profit', forecastVals, compareSelectedYear, previousYear, numberOfMonths, isForecast, fallbackPrevYearData)
    }

    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;

  } else if (row.key === 'net_profit') {
    // Just use a month's values
    youValues = monthlyNetProfit(calcs, year, numberOfMonths)
    if (compareWith === 'Default:YOY') {
      compareValues = monthlyNetProfit(calcs, previousYear, numberOfMonths)
    } else if (compareWith === 'Default:Peers') {
      compareValues = monthlyNetProfit(calcsPeers, year, numberOfMonths)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = monthlyNetProfit(forecastVals, compareSelectedYear, numberOfMonths)
    }

    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;

  } else if (row.key === 'days_cash_on_hand') {
    // Just use a month's values
    youValues = monthlyDaysCashOnHand(calcs, year, numberOfMonths)
    if (compareWith === 'Default:YOY') {
      compareValues = monthlyDaysCashOnHand(calcs, previousYear, numberOfMonths)
    } else if (compareWith === 'Default:Peers') {
      compareValues = monthlyDaysCashOnHand(calcsPeers, year, numberOfMonths)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = monthlyDaysCashOnHand(forecastVals, compareSelectedYear, numberOfMonths)
    }

    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;

  } else if (row.key === 'quick_ratio') {
    // Just use a month's values
    youValues = monthlyQuickRatio(calcs, year, numberOfMonths)
    if (compareWith === 'Default:YOY') {
      compareValues = monthlyQuickRatio(calcs, previousYear, numberOfMonths)
    } else if (compareWith === 'Default:Peers') {
      compareValues = monthlyQuickRatio(calcsPeers, year, numberOfMonths)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = monthlyQuickRatio(forecastVals, compareSelectedYear, numberOfMonths)
    }

    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;

  } else if (row.key === 'debt_ratio') {
    // Just use a month's values
    youValues = monthlyDebtRatio(calcs, year, numberOfMonths)
    if (compareWith === 'Default:YOY') {
      compareValues = monthlyDebtRatio(calcs, previousYear, numberOfMonths)
    } else if (compareWith === 'Default:Peers') {
      compareValues = monthlyDebtRatio(calcsPeers, year, numberOfMonths)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = monthlyDebtRatio(forecastVals, compareSelectedYear, numberOfMonths)
    }

    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;
  } else if (row.key === 'operating_cash_flow_kfi' || row.key === 'cash_flow_margin') {
    // Just use a month's values
    youValues = monthlyOperatingCashFlow(row.key, calcs, year, previousYear, numberOfMonths)
    //  Not sure here...
    if (compareWith === 'Default:YOY') {
      compareValues = monthlyOperatingCashFlow(row.key, calcs, previousYear, twoYearsAgo, numberOfMonths)
    } else if (compareWith === 'Default:Peers') {
      compareValues = monthlyOperatingCashFlow(row.key, calcsPeers, year, previousYear, numberOfMonths)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = monthlyOperatingCashFlow(row.key, forecastVals, compareSelectedYear, previousYear, numberOfMonths, isForecast, fallbackPrevYearData)
    }

    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;

  } else if (row.key === 'net_working_capital') {
    // Given net working capital ratio values are not correct and need to be recalculated
    youValues = netWorkingCapitalCalculation(calcs, year)

    if (compareWith === 'Default:YOY') {
      compareValues = netWorkingCapitalCalculation(calcs, previousYear)
    } else if (compareWith === 'Default:Peers') {
      compareValues = netWorkingCapitalCalculation(calcsPeers, year)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = netWorkingCapitalCalculation(forecastVals, compareSelectedYear)
    }
    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;
  } else if (row.key === 'net_working_capital_ratio') {
    youValues = netWorkingCapitalRatioCalculation(calcs, year)

    if (compareWith === 'Default:YOY') {
      compareValues = netWorkingCapitalRatioCalculation(calcs, previousYear)
    } else if (compareWith === 'Default:Peers') {
      compareValues = netWorkingCapitalRatioCalculation(calcsPeers, year)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = netWorkingCapitalRatioCalculation(forecastVals, compareSelectedYear)
    }
    let youCalcsLength = Object.values(youValues).length
    ytdYou = youValues[youCalcsLength]
    ytdCompare = compareValues ? compareValues[youCalcsLength] : null;
  } else if (trailing12MonthsKeys.includes(row.key)) {
    youValues = trailing12MonthCalculations(row.copy, calcs, year, previousYear)

    if (compareWith === 'Default:YOY') {
      compareValues = trailing12MonthCalculations(row.copy, calcs, previousYear, twoYearsAgo)
    } else if (compareWith === 'Default:Peers') {
      compareValues = trailing12MonthCalculations(row.copy, calcsPeers, year, previousYear)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = trailing12MonthCalculations(row.copy, forecastVals, compareSelectedYear, previousYear, isForecast, fallbackPrevYearData)
    }
    if (youValues) {
      let youCalcsLength = Object.values(youValues).slice(0, numberOfMonths).length
      ytdYou = youValues[youCalcsLength]
      ytdCompare = compareValues ? compareValues[youCalcsLength] : null;
    } else {
      ytdYou = null
      ytdCompare = null
    }
  } else if (row.key === 'ebitda') {
    youValues = calculateEBITDA(calcs, year)

    if (compareWith === 'Default:YOY') {
      compareValues = calculateEBITDA(calcs, previousYear)
    } else if (compareWith === 'Default:Peers') {
      compareValues = calculateEBITDA(calcsPeers, year)
    } else if (compareWith && compareWith.includes('Forecast')) {
      compareValues = calculateEBITDA(forecastVals, compareSelectedYear)
    }
    let youCalcsLength = Object.values(youValues).length
    let arrayOfComparisonCalcedVals = [];
    for (let i = 1; i <= youCalcsLength; i++) {
      compareValues ? arrayOfComparisonCalcedVals.push(compareValues[i]) : arrayOfComparisonCalcedVals.push(null)
    }
    ytdYou = Object.values(youValues).reduce((a, b) => a + b, 0)
    ytdCompare = compareValues ? arrayOfComparisonCalcedVals.reduce((a, b) => a + b, 0) : null;
  } else if (ebitdaKeys.includes(row.key)) {
    youValues = calcs?.[row.key]?.[year]
    if (youValues) {
      if (compareWith === 'Default:YOY') {
        compareValues = calcs?.[row.key]?.[previousYear]
      } else if (compareWith === 'Default:Peers') {
        compareValues = calcsPeers?.[row.key]?.[year]
      } else if (compareWith && compareWith.includes('Forecast')) {
        compareValues = forecastVals?.[row.key]?.[compareSelectedYear]
      }
      let youCalcsLength = 0
      Object.values(youValues).forEach(value => value !== null ? youCalcsLength += 1 : null)
      let arrayOfComparisonCalcedVals = [];
      if (compareValues) {
        for (let i = 1; i <= youCalcsLength; i++) {
          arrayOfComparisonCalcedVals.push(compareValues[i])
        }
      }
      ytdYou = Object.values(youValues).reduce((a, b) => a + b, 0)
      ytdCompare = compareValues ? arrayOfComparisonCalcedVals.reduce((a, b) => a + b, 0) : null;
    }
  }

  return { youValues, compareValues, ytdYou, ytdCompare };
}

const cashFlowTitleKeys = [
  {
    title: 'Cash flow from operating activities:',
    paddingLeft: 0,
    fontStyle: 'none',
  },
  {
    title: 'Net Income',
    key: 'operating_expenses_net_income',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Depreciation & Amortization',
    key: 'depreciation_and_amortization',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Accounts Receivable',
    key: 'accounts_receivable',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Inventory',
    key: 'inventory',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Under-Billings',
    key: 'under_billings',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Prepaid & Other Current Assets',
    key: 'prepaid_and_other_current_assets',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Accounts Payable',
    key: 'accounts_payable',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Accrued Liabilities',
    key: 'accrued_liabilities',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Over-Billings',
    key: 'over_billings',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Other Current Liabilities',
    key: 'other_current_liabilities',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Net cash flow from operating activities',
    key: 'net_operating_activities',
    paddingLeft: 0,
    fontStyle: 'italic',
  },
  {
    title: 'Cash flow from investing activities:',
    paddingLeft: 0,
    fontStyle: 'none',
  },
  {
    title: 'Property & Equipment',
    key: 'property_and_equipment',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Other Long Term Assets',
    key: 'other_long_term_assets',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Net cash flow from investing activities',
    key: 'net_investing_activities',
    paddingLeft: 0,
    fontStyle: 'italic',
  },
  {
    title: 'Cash flow from financing activities:',
    paddingLeft: 0,
    fontStyle: 'none',
  },
  {
    title: 'Line of Credit',
    key: 'line_of_credit',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Current Portion of LTD',
    key: 'current_portion_of_ltd',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Long Term Debt',
    key: 'long_term_debt',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Equity',
    key: 'equity',
    paddingLeft: '18px',
    fontStyle: 'none',
  },
  {
    title: 'Net cash flow from financing activities',
    key: 'net_financing_activities',
    paddingLeft: 0,
    fontStyle: 'italic',
  },
  {
    title: 'Net change in cash and cash equivalents',
    key: 'net_change_cash',
    paddingLeft: 0,
    fontStyle: 'none',
  },
  {
    title: 'Cash at beginning of period',
    key: 'cash',
    paddingLeft: 0,
    fontStyle: 'none',
  },
  {
    title: 'Cash at end of period',
    key: 'cash',
    paddingLeft: 0,
    fontStyle: 'none',
  },
  {
    title: 'Free Cash Flow:',
    paddingLeft: 0,
    fontStyle: 'none',
  },
  {
    title: 'Operating cash flow',
    key: 'operating_cash_flow',
    paddingLeft: 0,
    fontStyle: 'none',
  },
  {
    title: 'Capital Expenditure',
    key: 'capital_expenditure',
    paddingLeft: 0,
    fontStyle: 'none',
  },
  {
    title: 'Free Cash Flow',
    key: 'free_cash_flow',
    paddingLeft: 0,
    fontStyle: 'italic',
  }
];

const objReducer = (obj) => {
  let reducedObject = undefined;
  if (obj) {
    reducedObject = Object.values(obj).reduce((a, b) => a + b, 0);
  }
  return reducedObject;
}

const sumForYTDMonths = (obj = {}, ytdMonths = []) => {
  return (ytdMonths || []).map(m => obj[m]).filter(_.isNumber).reduce((a, b) => a + b, 0);
}
// 2 Year YTD calculations not trailing 12 calcs! We use monthly values for the 2 yeat YTD.
const calculateCurrentRatio = (calcs, selectedYear, ytdMonths) => {
  const currentAssets = calcs?.total_current_assets?.[selectedYear] || {};
  const currentLiabilities = calcs?.total_current_liabilities?.[selectedYear] || {};

  const ytdAssets = sumForYTDMonths(currentAssets, ytdMonths);
  const ytdLiabilities = sumForYTDMonths(currentLiabilities, ytdMonths);

  return ytdLiabilities ? (ytdAssets / ytdLiabilities) : null;
};

const calculateNetWorkingCapital = (calcs, selectedYear, ytdMonths) => {
  const currentAssets = calcs?.total_current_assets?.[selectedYear] || {};
  const currentLiabilities = calcs?.total_current_liabilities?.[selectedYear] || {};

  const ytdAssets = sumForYTDMonths(currentAssets, ytdMonths);
  const ytdLiabilities = sumForYTDMonths(currentLiabilities, ytdMonths);

  return ytdAssets - ytdLiabilities;
};

const calculateNetWorkingCapitalRatio = (calcs, selectedYear, ytdMonths) => {
  const totalAssets = calcs?.total_assets?.[selectedYear] || {};
  const currentAssets = calcs?.total_current_assets?.[selectedYear] || {};
  const currentLiabilities = calcs?.total_current_liabilities?.[selectedYear] || {};

  const ytdAssets = sumForYTDMonths(totalAssets, ytdMonths);
  const ytdCurrentAssets = sumForYTDMonths(currentAssets, ytdMonths);
  const ytdCurrentLiabilities = sumForYTDMonths(currentLiabilities, ytdMonths);

  return ytdAssets ? ((ytdCurrentAssets - ytdCurrentLiabilities) / ytdAssets) : null;
};

const calculateROA = (calcs, selectedYear, ytdMonths) => {
  const totalAssets = sumForYTDMonths(calcs?.total_assets?.[selectedYear], ytdMonths);
  const netIncome = sumForYTDMonths(calcs?.operating_expenses_net_income?.[selectedYear], ytdMonths);
  return totalAssets ? netIncome / totalAssets : null;
};

const calculateROE = (calcs, selectedYear, ytdMonths) => {
  const netWorth = sumForYTDMonths(calcs?.net_worth?.[selectedYear], ytdMonths);
  const netIncome = sumForYTDMonths(calcs?.operating_expenses_net_income?.[selectedYear], ytdMonths);
  return netWorth ? netIncome / netWorth : null;
};

const calculateROCE = (calcs, selectedYear, ytdMonths) => {
  const netWorth = sumForYTDMonths(calcs?.net_worth?.[selectedYear], ytdMonths);
  const longTermDebt = sumForYTDMonths(calcs?.long_term_debt?.[selectedYear], ytdMonths);
  const operatingProfit = sumForYTDMonths(calcs?.operating_profit?.[selectedYear], ytdMonths);

  const denominator = netWorth + longTermDebt;
  return denominator ? operatingProfit / denominator : null;
};

const calculateROI = (calcs, selectedYear, ytdMonths) => {
  const netIncome = sumForYTDMonths(calcs?.operating_expenses_net_income?.[selectedYear], ytdMonths);
  const capitalStock = sumForYTDMonths(calcs?.capital_stock?.[selectedYear], ytdMonths);
  return capitalStock ? netIncome / capitalStock : null;
};

const calculateNetProfit = (calcs, selectedYear, ytdMonths) => {
  const revenue = calcs?.total_revenue?.[selectedYear] || {};
  const netIncome = calcs?.operating_expenses_net_income?.[selectedYear] || {};

  const ytdRevenue = sumForYTDMonths(revenue, ytdMonths);
  const ytdNetIncome = sumForYTDMonths(netIncome, ytdMonths);

  return ytdRevenue ? (ytdNetIncome / ytdRevenue) : null;
};

const calculateDaysCash = (calcs, selectedYear, ytdMonths) => {
  const totalOpEx = calcs?.total_operating_expenses?.[selectedYear] || {};
  const cash = calcs?.cash?.[selectedYear] || {};
  const interest = calcs?.interest_and_other_expenses?.[selectedYear] || {};
  const taxes = calcs?.['total_other_costs_taxes_- federal & state']?.[selectedYear] || {};
  const otherIncome = calcs?.other_income_expenses?.[selectedYear] || {};

  const ytdOpEx = sumForYTDMonths(totalOpEx, ytdMonths);
  const ytdCash = sumForYTDMonths(cash, ytdMonths);
  const ytdInterest = sumForYTDMonths(interest, ytdMonths);
  const ytdTaxes = sumForYTDMonths(taxes, ytdMonths);
  const ytdOtherIncome = sumForYTDMonths(otherIncome, ytdMonths);

  let daysCash = (ytdOpEx + ytdInterest + ytdTaxes + ytdOtherIncome) / 365;

  return daysCash ? ytdCash / daysCash : null;
};

const calculateQuickRatio = (calcs, selectedYear, ytdMonths) => {
  const totalCL = calcs?.total_current_liabilities?.[selectedYear] || {};
  const totalAssets = calcs?.total_current_assets?.[selectedYear] || {};
  const inventory = calcs?.inventory?.[selectedYear] || {};

  const ytdCL = sumForYTDMonths(totalCL, ytdMonths);
  const ytdAssets = sumForYTDMonths(totalAssets, ytdMonths);
  const ytdInventory = sumForYTDMonths(inventory, ytdMonths);

  return ytdCL ? (ytdAssets - ytdInventory) / ytdCL : null;
};

const calculateDebtRatio = (calcs, selectedYear, ytdMonths) => {
  const totalAssets = calcs?.total_assets?.[selectedYear] || {};
  const totalCL = calcs?.total_current_liabilities?.[selectedYear] || {};
  const longTermDebt = calcs?.long_term_debt?.[selectedYear] || {};

  const ytdAssets = sumForYTDMonths(totalAssets, ytdMonths);
  const ytdCL = sumForYTDMonths(totalCL, ytdMonths);
  const ytdLongTermDebt = sumForYTDMonths(longTermDebt, ytdMonths);
  return ytdAssets ? (ytdCL + ytdLongTermDebt) / ytdAssets : null;
}

const calculateOperatingCashFlow = (calcs, selectedYear, previousYear, ytdMonths, fallbackYouData = null) => {
  const totalCL = calcs?.total_current_liabilities?.[selectedYear] || {};
  const ytdCL = sumForYTDMonths(totalCL, ytdMonths);
  let opCashFLow = netOperatingActivitiesValuesMonths(calcs, selectedYear, previousYear, true, ytdMonths, true, fallbackYouData);
  return ytdCL ? (opCashFLow / ytdCL) : null;
}

const calculateCashFlowMargin = (calcs, selectedYear, previousYear, ytdMonths, fallbackYouData = null) => {
  let totalRevenue = calcs?.total_revenue?.[selectedYear] || {};
  const ytdRevenue = sumForYTDMonths(totalRevenue, ytdMonths);
  let opCashFLow = netOperatingActivitiesValuesMonths(calcs, selectedYear, previousYear, true, ytdMonths, true, fallbackYouData);
  return ytdRevenue ? (opCashFLow / ytdRevenue) : null;
}

const calculateGrossProfit = (calcs, selectedYear, ytdMonths) => {
  const totalRevenue = sumForYTDMonths(calcs?.total_revenue?.[selectedYear], ytdMonths);
  const grossProfit = sumForYTDMonths(calcs?.gross_profit?.[selectedYear], ytdMonths);
  return totalRevenue ? (grossProfit / totalRevenue) : null;
};

const calculateOperatingProfit = (calcs, selectedYear, ytdMonths) => {
  const totalRevenue = sumForYTDMonths(calcs?.total_revenue?.[selectedYear], ytdMonths);
  const operatingProfit = sumForYTDMonths(calcs?.operating_profit?.[selectedYear], ytdMonths);
  return totalRevenue ? (operatingProfit / totalRevenue) : null;
};

const calculateAssetTurnoverRatio = (calcs, selectedYear, ytdMonths) => {
  const totalAssets = sumForYTDMonths(calcs?.total_assets?.[selectedYear], ytdMonths);
  const totalRevenue = sumForYTDMonths(calcs?.total_revenue?.[selectedYear], ytdMonths);
  return totalAssets ? totalRevenue / totalAssets : null;
};

const calculateInventoryTurnoverRatio = (calcs, selectedYear, previousYear, ytdMonths, fallbackYouData = null) => {
  const currentYearInventory = sumForYTDMonths(calcs?.inventory?.[selectedYear], ytdMonths);
  const previousYearInventory = fallbackYouData ? sumForYTDMonths(fallbackYouData?.inventory?.[previousYear], ytdMonths) : sumForYTDMonths(calcs?.inventory?.[previousYear], ytdMonths);
  const materialCosts = sumForYTDMonths(calcs?.materials_costs?.[selectedYear], ytdMonths);
  let denominator = (currentYearInventory + previousYearInventory);
  return denominator ? (materialCosts / ((denominator) / 2)) : null;
}

const calculateARDays = (calcs, selectedYear, ytdMonths) => {
  const accountsReceivable = sumForYTDMonths(calcs?.accounts_receivable?.[selectedYear], ytdMonths);
  const totalRevenue = sumForYTDMonths(calcs?.total_revenue?.[selectedYear], ytdMonths);
  return totalRevenue ? ((360 * accountsReceivable) / totalRevenue) : null;
};

const calculateAPDays = (calcs, selectedYear, ytdMonths) => {
  const accountsPayable = sumForYTDMonths(calcs?.accounts_payable?.[selectedYear], ytdMonths);
  const totalCosts = sumForYTDMonths(calcs?.total_costs?.[selectedYear], ytdMonths);
  const laborCosts = sumForYTDMonths(calcs?.labor_costs?.[selectedYear], ytdMonths);
  const totalOpEx = sumForYTDMonths(calcs?.total_operating_expenses?.[selectedYear], ytdMonths);
  const taxBenies = sumForYTDMonths(calcs?.total_taxes_and_benefits?.[selectedYear], ytdMonths);
  const totalCompensation = sumForYTDMonths(calcs?.total_compensation?.[selectedYear], ytdMonths);

  const denominator = (totalCosts - laborCosts + totalOpEx - taxBenies - totalCompensation);
  return denominator ? ((360 * accountsPayable) / denominator) : null;
};

const calculateDebtToEquity = (calcs, selectedYear, ytdMonths) => {
  const netWorth = sumForYTDMonths(calcs?.net_worth?.[selectedYear], ytdMonths);
  const totalCurrentLiabilities = sumForYTDMonths(calcs?.total_current_liabilities?.[selectedYear], ytdMonths);
  const longTermDebt = sumForYTDMonths(calcs?.long_term_debt?.[selectedYear], ytdMonths);

  return netWorth ? ((totalCurrentLiabilities + longTermDebt) / netWorth) : null;
};

const calculateEBITDAnormal = (calcs, selectedYear, ytdMonths) => {
  const netIncome = sumForYTDMonths(calcs?.operating_expenses_net_income?.[selectedYear], ytdMonths);
  const interest = sumForYTDMonths(calcs?.interest_and_other_expenses?.[selectedYear], ytdMonths);
  const taxes = sumForYTDMonths(calcs?.['total_other_costs_taxes_- federal & state']?.[selectedYear], ytdMonths);
  const depreciation = sumForYTDMonths(calcs?.depreciation_and_amortization?.[selectedYear], ytdMonths);

  return netIncome + interest + taxes + depreciation;
};

const calculateSeniorDebtToEBITDA = (calcs, selectedYear, ytdMonths = []) => {
  const ebitda = calculateEBITDAnormal(calcs, selectedYear, ytdMonths);
  if (!ebitda) return null;

  const longTermDebt = sumForYTDMonths(calcs?.long_term_debt?.[selectedYear], ytdMonths);
  const loc = sumForYTDMonths(calcs?.line_of_credit?.[selectedYear], ytdMonths);
  const currentPortion = sumForYTDMonths(calcs?.current_portion_of_ltd?.[selectedYear], ytdMonths);

  return (longTermDebt + loc + currentPortion) / ebitda;
};

const calculateEBITDAtoAnnualInterest = (calcs, selectedYear, ytdMonths = []) => {
  const ebitda = calculateEBITDAnormal(calcs, selectedYear, ytdMonths);
  const interest = sumForYTDMonths(calcs?.['interest_and_other_expenses']?.[selectedYear], ytdMonths);

  return interest ? ebitda / interest : null;
};

// Calulations for 2 Year to Date KFI metrics. Not trailing 12 months.
// key, calcs, prevYearCalcsMonthly, prevYearCalcsMonthlyFullYear
const calculateKFIMetric = (key, calcs, selectedYear, previousYear, ytdMonths, fallbackYouData = null) => {
  let finalValue;
  switch (key) {
    case ('total_revenue_growth_rate'):
      finalValue = ytdTotalRevenueGRCalc(calcs, selectedYear, previousYear, ytdMonths, fallbackYouData)
      break;
    case ('net_profit'):
      finalValue = calculateNetProfit(calcs, selectedYear, ytdMonths)
      break;
    case ('days_cash_on_hand'):
      finalValue = calculateDaysCash(calcs, selectedYear, ytdMonths)
      break;
    case ('quick_ratio'):
      finalValue = calculateQuickRatio(calcs, selectedYear, ytdMonths)
      break;
    case ('debt_ratio'):
      finalValue = calculateDebtRatio(calcs, selectedYear, ytdMonths)
      break;
    case ('operating_cash_flow_kfi'):
      // Need full previous year of months
      finalValue = calculateOperatingCashFlow(calcs, selectedYear, previousYear, ytdMonths, fallbackYouData)
      break;
    case ('cash_flow_margin'):
      // Need full previous year of months
      finalValue = calculateCashFlowMargin(calcs, selectedYear, previousYear, ytdMonths, fallbackYouData)
      break;
    case ('current_ratio'):
      finalValue = calculateCurrentRatio(calcs, selectedYear, ytdMonths);
      break;
    case ('net_working_capital'):
      finalValue = calculateNetWorkingCapital(calcs, selectedYear, ytdMonths);
      break;
    case ('net_working_capital_ratio'):
      finalValue = calculateNetWorkingCapitalRatio(calcs, selectedYear, ytdMonths);
      break;
    case ('roa'):
      finalValue = calculateROA(calcs, selectedYear, ytdMonths);
      break;
    case ('roe'):
      finalValue = calculateROE(calcs, selectedYear, ytdMonths);
      break;
    case ('roce'):
      finalValue = calculateROCE(calcs, selectedYear, ytdMonths);
      break;
    case ('mkt_roi'):
      finalValue = calculateROI(calcs, selectedYear, ytdMonths);
      break;
    case ('gross_profit'):
      finalValue = calculateGrossProfit(calcs, selectedYear, ytdMonths);
      break;
    case ('operating_profit'):
      finalValue = calculateOperatingProfit(calcs, selectedYear, ytdMonths);
      break;
    case ('asset_turnover_ratio'):
      finalValue = calculateAssetTurnoverRatio(calcs, selectedYear, ytdMonths);
      break;
    case ('inventory_turnover_ratio'):
      // don't need full previous year of months
      finalValue = calculateInventoryTurnoverRatio(calcs, selectedYear, previousYear, ytdMonths, fallbackYouData);
      break;
    case ('ar_days'):
      finalValue = calculateARDays(calcs, selectedYear, ytdMonths);
      break;
    case ('ap_days'):
      finalValue = calculateAPDays(calcs, selectedYear, ytdMonths);
      break;
    case ('debt_to_equity'):
      finalValue = calculateDebtToEquity(calcs, selectedYear, ytdMonths);
      break;
    case ('senior_debt_to_ebitda'):
      finalValue = calculateSeniorDebtToEBITDA(calcs, selectedYear, ytdMonths);
      break;
    case ('ebitda_to_annual_interest'):
      finalValue = calculateEBITDAtoAnnualInterest(calcs, selectedYear, ytdMonths);
      break;
    case ('ebitda'):
      finalValue = calculateEBITDAnormal(calcs, selectedYear, ytdMonths);
      break;
    default:
      finalValue = sumForYTDMonths(calcs?.[key]?.[selectedYear], ytdMonths);
      break;
  }
  return finalValue;
}
// Testing Revenue per Month Percentage of Total Revenue of given year 
const monthlyTotalRevenueGRCalc = (calcs, year, forecast = false) => {
  let returnObject = {};
  let currentYearTotalRevenue = 0;
  let currentYearMonthlyTotalRevenue = 0
  if (forecast) {
    currentYearTotalRevenue = calcs?.total_revenue ? objReducer(calcs?.total_revenue) : 0;
    currentYearMonthlyTotalRevenue = calcs?.total_revenue ? _.pickBy(calcs?.total_revenue, _.isNumber) : {};
  } else {
    currentYearTotalRevenue = calcs?.total_revenue?.[year] ? objReducer(calcs?.total_revenue?.[year]) : 0;
    currentYearMonthlyTotalRevenue = calcs?.total_revenue?.[year] ? _.pickBy(calcs?.total_revenue[year], _.isNumber) : {};
  }
  for (let month in currentYearMonthlyTotalRevenue) {
    returnObject[month] = (currentYearMonthlyTotalRevenue[month] / currentYearTotalRevenue)
  }
  return returnObject;
  // Old Monthly Revenue Growth Rate formula
  // (previous month / current month) - 1;
  // let previousYearTotalRevenue = previousYearCalcs.total_revenue;
  // if (previousYearTotalRevenue[12]) {
  //   returnObject[1] = (currentYearTotalRevenue[1] / previousYearTotalRevenue[12]) - 1;
  // } else {
  //   returnObject[1] = 0;
  // }
  // for (let i = 2; i < 13; i++) {
  //   returnObject[i] = (currentYearTotalRevenue[i] / currentYearTotalRevenue[i-1]) - 1;
  // }
}
// YTD Revenue Growth Rate
const ytdTotalRevenueGRCalc = (calcs, selectedYear, previousYear, ytdMonths, fallbackYouData = null) => {
  let finalValue = 0;
  const selectedYearValues = calcs?.total_revenue?.[selectedYear] || {};
  const previousYearValues = fallbackYouData ? fallbackYouData?.total_revenue?.[previousYear] || {} : calcs?.total_revenue?.[previousYear] || {};

  const currentYTDRevenue = (ytdMonths || []).map(month => selectedYearValues[month]).filter(_.isNumber).reduce((a, b) => a + b, 0);
  const previousYTDRevenue = (ytdMonths || []).map(month => previousYearValues[month]).filter(_.isNumber).reduce((a, b) => a + b, 0);
  if (previousYTDRevenue) {
    finalValue = (currentYTDRevenue / previousYTDRevenue) - 1;
  }
  return finalValue;
}

// Monthly % of Revenue Metric calculations
const monthlyPercentOfRevenueCalc = (percentOfRevenueKey, key, calcs, year) => {
  let returnObj = {};
  let currentYearTotalRevenue = calcs?.total_revenue?.[year] || {};
  const metricValues = calcs?.[percentOfRevenueKey] && typeof calcs?.[percentOfRevenueKey] === 'object'
    ? _.pickBy(calcs?.[percentOfRevenueKey]?.[year], _.isNumber)
    : { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0 }

  for (let month in metricValues) {
    const revenue = currentYearTotalRevenue[month] ?? null
    const value = metricValues[month] ?? null

    if (revenue !== null && revenue !== 0) {
      if (key === 'gross_margin') {
        returnObj[month] = (revenue - value) / revenue
      } else {
        returnObj[month] = value / revenue
      }
    } else {
      returnObj[month] = null
    }
  }
  return returnObj;
}

// YTD % of Revenue Metric calculations
const ytdPercentOfRevenueCalc = (percentOfRevenueKey, key, calcs, year, ytdMonths = []) => {
  let finalValue = 0;
  let ytdTotalRevenue = getYTDMonths(calcs?.total_revenue[year], ytdMonths).reduce((a, b) => a + b, 0);
  let metricValues = getYTDMonths(calcs?.[percentOfRevenueKey][year], ytdMonths).reduce((a, b) => a + b, 0);

  if (key === 'gross_margin') {
    finalValue = (ytdTotalRevenue - metricValues) / ytdTotalRevenue;
  } else {
    finalValue = metricValues / ytdTotalRevenue;
  }
  return finalValue;
}


export { CommonSizeArrowsHelper, CommonSizeArrows, CashFlowCommonSizeArrows, YTDNAICSFocusedVals, YTDPnlandBalCommonSizeValue, YTDPnlandBalValues, MonthlyPNLandBalValues, MonthlyPNLandBalCommonSized, YTDCashFlowValues, MonthlyNAICSFocusedVals, MonthlyCashFlowValues, AnnualCashFlowValues, MonthlyKFIsValues, AnnualKFIsValues, KFIsCommonSizeArrows, cashFlowTitleKeys, objReducer, calculateKFIMetric, calculateSeniorDebtToEBITDA, calculateEBITDAtoAnnualInterest, monthlyTotalRevenueGRCalc, monthlyPercentOfRevenueCalc, ytdPercentOfRevenueCalc, ytdTotalRevenueGRCalc };
